"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.masterFAQ = exports.masterPolicies = void 0;
const images_1 = require("../assets/images");
exports.masterPolicies = [
    {
        title: '各種利用規約',
        items: [
            {
                title: '利用規約',
                content: `
        <style>
        .p {
          font-weight: 700;
          font-family: 'Hiragino Kaku Gothic Pro W6';
        }
        .blank-line,
        .p {
          margin: 0;
        }
        .span {
          font-weight: 700;
          font-family: 'Hiragino Kaku Gothic Pro W6';
        }
        .span1 {
          text-decoration: underline;
        }
        .a {
          color: inherit;
        }
        .span2 {
          color: #292a33;
        }
        .span3 {
          text-decoration: underline;
          color: #007aff;
        }
        .li {
          margin-bottom: 0;
        }
        .senpaiac {
          margin: 0;
          padding-left: 19px;
        }
        .p3 {
          margin: 0;
          font-size: 15px;
        }
        .blank-line13,
        .policy-body {
          font-size: 15px;
          font-family: "Hiragino Kaku Gothic ProN";
        }
        .policy-body {
          width: 100%;
          position: relative;
          line-height: 150%;
          text-align: left;
          display: inline-block;
          font-size: 14px;
          color: #292A33;
        }
        
        </style>
        <div class="policy-body">
      <p class="p">
        <span>
          <span>
            <span>利用規約について</span>
          </span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>
            <span>&nbsp;</span>
          </span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>
            <span
              >この利用規約（以下「利用規約」）は、株式会社富士山マガジンサービス（以下「当社」）の運営する、コミュニティサービス「投資の先輩」（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます。以下「本サービス」）の利用者（以下「お客様」）が、本サービスの利用に際して遵守すべき事項を定めたものです。</span
            >
            <span class="span"
              >お客様が本サービスを利用した場合、そのお客様は利用規約に同意したものとみなします。</span
            >
            <span>なお、別紙「</span>
          </span>
        </span>
        <span>
            <span>
              プライバシーポリシー
            </span>
          </span>
        <span>
          <span>
            <span class="span2">」、「</span>
          </span>
        </span>
        <span>
            <span>
              金融商取引法に関するポリシー
            </span>
          </span>
        <span>
          <span>
            <span class="span2">」、「</span>
          </span>
        </span>
        <span>
            <span>
              コニュニティガイドライン
            </span>
          </span>
        <span>
          <span>
            <span
              >」に記載された全ての内容は、利用規約と一体のものとして、お客様はその内容に同意したものとみなします。</span
            >
          </span>
        </span>
      </p>
      <p class="p">
        <span>
          <span>
            <span>&nbsp;</span>
          </span>
        </span>
      </p>
      <p class="blank-line p">
        <span>
          <span>
            <span>定義等について</span>
          </span>
        </span>
      </p>
      <ul class="senpaiac">
        <li class="li">
          <span>
            <span>
              <span
                >お客様のうち、コンテンツの制作および配信又は各種サービスの運営をし、本サービス上でお客様に対し購読・閲覧その他の利用をさせる者を「投稿者」（「投稿者」には出版社を含みます。）といいます。</span
              >
            </span>
          </span>
        </li>
        <li class="li">
          <span>
            <span>
              <span
                >「コンテンツ」とは、お客様が本サービスを利用して投稿その他送信する予定、コメントその他のコンテンツ（文章、画像、動画その他のデータを含みますがこれらに限りません。）を意味します。</span
              >
            </span>
          </span>
        </li>
        <li class="li">
          <span>
            <span>
              <span
                >「本サイト」とは、そのドメインが「senpai.ac」である当社が運営するウェブサイト（理由の如何を問わず当社のウェブサイトのドメイン又は内容が変更された場合は、当該変更後のウェブサイトを含みます。）を意味します。</span
              >
            </span>
          </span>
        </li>
      </ul>
      <p class="blank-line">
        <span>
          <span>
            <span>&nbsp;</span>
          </span>
        </span>
      </p>
      <p class="p p3">
        <span>
          <span>登録について</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>
            1.本サービスの利用を希望する者（以下「登録希望者」）は、利用規約を遵守することに同意し、かつ当社の定める一定の情報（以下「登録情報」といいます。）を当社の定める方法で当社に提供することにより、当社に対し、本サービスの利用の登録を申請することができます。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>
            2.
            登録の申請は必ず本サービスを利用する個人又は法人自身が行わなければならず、原則として代理人による登録申請は認められません。また、登録希望者は、登録の申請にあたり、真実、正確かつ最新の情報を当社に提供しなければなりません。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>
            3.
            当社は、第1項に基づき登録を申請した者が、以下の各号のいずれかの事由に該当する場合は、登録を拒否することがあります。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>(1) 利用規約に違反するおそれがあると当社が判断した場合</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >(2)
            当社に提供された登録情報の全部又は一部につき虚偽、誤記又は記載漏れがあった場合</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >(3) 過去に本サービスの利用の登録を取り消された者である場合</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >(4)
            未成年者、成年被後見人、被保佐人又は被補助人のいずれかであり、法定代理人、後見人､保佐人又は補助人の同意等を得ていなかった場合</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >(5)
            反社会的勢力等（暴力団、暴力団員、暴力団準構成員、暴力団員又は暴力団準構成員でなくなった日から5年を経過しない者、暴力団関係企業、総会屋、社会運動等標ぼうゴロ、特殊知能暴力集団その他暴力、威力又は詐欺的手法を使用して経済的利益を追求する集団又は個人を意味します。以下同じ。）である、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていると当社が判断した場合</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>(6) その他、当社が登録を適当でないと合理的に判断した場合</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>
            4.
            当社は、前項その他当社の基準に従って、登録希望者の登録の可否を判断し、当社が登録を認める場合にはその旨を登録希望者に通知します。かかる通知により登録希望者のお客様としての登録は完了し、利用規約の諸規定に従った本サービスの利用にかかる契約（以下「利用契約」）がお客様と当社の間に成立します。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>
            5.
            お客様は、登録情報に変更があった場合は、遅滞なく、当社の定める方法により、当該変更事項を当社に通知し、当社から要求された資料を提出するものとします。</span
          >
        </span>
      </p>
      <p class="p3">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="blank-line p">
        <span>
          <span>未成年者の利用者について</span>
        </span>
      </p>
      <ul class="senpaiac">
        <li class="li">
          <span>
            <span
              >未成年者のお客様が、親権者等の同意がないにもかかわらず、それを偽り本サービスを利用した場合、本サービスに関する一切の法律行為（コンテンツの投稿等による当社への利用権の付与等を含みます。）を取り消すことはできません。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >この利用規約の同意時に未成年者であったお客様が成年に達した後に本サービスを利用した場合、当該お客様は本サービスに関する一切の法律行為を追認したものとみなします。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >当社は、お客様に対するコンテンツの提供にあたり、未成年者のお客様がいることを踏まえて、必要と思われるゾーニングや注意喚起等に努めますが、親権者等の同意と適切な監督によらずに未成年者が本サービスを利用した場合に、その利用の結果について当社に故意又は重過失がある場合を除き、一切の責任を負いません。</span
            >
          </span>
        </li>
      </ul>
      <p class="blank-line">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="p3 p">
        <span>
          <span>本サービスの内容について</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >本サービスに掲載されている情報は、投資判断の参考となる情報提供を目的としており、投資等の勧誘又は推奨を目的としたものではございません。各種情報の内容について、内容の正確性、最新性、安全性について保証するものではございません。また、学習後の最終決定はお客様ご自身の自己責任による判断で行うものとし、投資資産における運用の結果生じた損害の全部もしくは一部については、自ら責任及び負担を負うものとします。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >当社は、法律上の請求原因の如何を問わず、いかなる場合においても当該情報の利用に関して生じたお客様に係る損害、損失、費用ならびに不利益等に関し、当社に故意又は重過失がある場合を除き、一切責任を負わないものとします。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="p3 p">
        <span>
          <span>サービスの価値について</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >本サービスで表示している価格は、全て税込み価格です。 今後、経済情勢の変動、消費税の税率変更等の事由に基づき、当社は代金を改定することができるものとします。</span
          >
        </span>
      </p>
      <p class="p3">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="blank-line p">
        <span>
          <span>返品・交換について</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >コンテンツについては商品の特性上、返品や返金、交換は承っておりません。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="p3 p">
        <span>
          <span>プライバシポリシーについて</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >本サービスをご利用いただくに際して、お客様より登録いただいた個人情報の取得主体は当社となります。当社は、その個人情報の取扱いに関しては、別途定める「</span
          >
        </span>
          <span>
              プライバシーポリシー
          </span>
        <span>
          <span>」に従うものとし、お客様はこれに同意するものとします。</span>
        </span>
      </p>
      <p class="p">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="p3 p">
        <span>
          <span>知的財産権について</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >当社が掲載した、本サイト上のデータの知的財産権は全て当社に帰属します。お客様は、本サービスで当社が提供する文章、画像、デザイン等あらゆる形の情報の一部又は全部を、利用許諾で認められた範囲を超えて使用をすることはできません。また、お客様は、他のお客様その他の第三者が知的財産権を所有しているコンテンツを、必要な許諾を得ずに、投稿してはなりません。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >お客様が本サービス上に投稿又は共有したコンテンツに関する知的財産権はお客様自身に帰属するものとします。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >お客様は、本サービスを通じて提供、投稿、又は共有したコンテンツに対して、当社に対する非独占的な知的財産権の利用許諾を行うものとします。この利用許諾により、当社は、本サービスの運営、宣伝、改善、又は派生サービスの提供に必要な範囲内で当該コンテンツを利用できるものとし、本サービス以外の外部での利用は行わないものとします。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >利用規約で別途定める場合を除き、お客様が自身のコンテンツを削除した場合、本サービス上からそのコンテンツが削除されるものとします。
            ただし、既に他のお客様によってコンテンツが共有又は引用された場合、当該コンテンツは当然には削除されないことについて、予め認識し、ご了承下さい。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >お客様が本サービス上に投稿したコンテンツは、個人的、非商業的な目的や商業的な目的で他のお客様によって利用されることがあるものとします。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >本サービスを退会することにより、お客様は投稿したコンテンツから生じる報酬を得る権利を失うものとします。退会後、コンテンツが商業的に利用されても、元の投稿者には報酬が支払われないものとします。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >お客様が本サービス上に投稿した記事・コメント、Q&A等のコンテンツは、その特性上訂正・削除することができないものとします。これは、コミュニティ全体の知識共有と情報の永続性を確保するためのものです。
            ただし、著作権侵害、プライバシー侵害、名誉毀損等の法的問題が発生した場合、権利侵害を受けた者は、以下の情報を明記の上、「</span
          >
        </span>
        <a
          class="a"
          href="https://www.fujisan.co.jp/pc/toushisenpai"
          target="_blank"
        >
          <span>
            <span>
              <span class="span3">お問い合わせ</span>
            </span>
          </span>
        </a>
        <span>
          <span> </span>
          <span class="span2"
            >」にて申立てを行うことができるものとします。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span class="span2">・住所、氏名、連絡先 </span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span class="span2">・侵害情報に関する詳細 </span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span class="span2">・侵害されたとする権利とその理由</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span class="span2">&nbsp;</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span class="span2"
            >お客様が利用規約の各規定に違反して生じた問題については、当社は、当社に故意又は重過失がある場合を除き、何ら責任を負わないものとし、お客様が自己の責任において問題を解決するものとします。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span class="span2">
          <span class="blank-line13">&nbsp;</span>
        </span>
      </p>
      <p class="blank-line p">
        <span class="span2">
          <span class="blank-line13">投稿について</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span class="span2"
            >本サービスにおける投稿に関する責任は、投稿者自身が負うものとします。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span class="span2"
            >当社は、投稿者が、本サービスにおいて投稿したコンテンツに関して、その正確性・速報性・合法性・完全性・有用性等を含む内容においていかなる保証もいたしません。したがって、当社は、当社に故意又は重過失がある場合を除き、投稿者に代わっての責任は負いかねます。投稿の内容については、お客様自身のご判断でご利用ください。投稿（リンクされた外部サイトを含みます）によって生じた損害（名誉、信用の毀損、及びコンピューターウィルス感染被害などによる損害も含みます）やお客様同士のトラブル等に対し、当社に故意又は重過失がある場合を除き、当社は一切の補償・関与をいたしません。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span class="span2">お客様ご自身が「</span>
        </span>
        <span>
            金融商品取引法に関するポリシー
          </span>
        <span>
          <span
            >」を確認の上で、利用・投稿をしていただくようお願い致します。</span
          >
        </span>
      </p>
      <p class="p3">
        <span>
          <span
            >お客様が以下に該当すると当社が判断した場合、お客様に事前に通知することなく当社はお客様のご利用を停止させて頂き、コンテンツを削除、又は検索結果からの除外などの措置をすることがあります。かかる利用の停止又はコンテンツの削除等によりお客様に損害が生じた場合であっても、当社は、当社に故意又は重過失がある場合を除き、損害賠償責任その他一切の責任を負わないものとします。</span
          >
        </span>
      </p>
      <ul class="senpaiac">
        <li class="li">
          <span>
            <span
              >当社、投稿者、他のお客様、情報提供元、権利保持者、販売提携会社、広告主など第三者の著作権、商標権等の知的財産権、その他の権利又は利益を侵害する行為、又は侵害するおそれのある行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span>利用規約に違反していると当社が独自に判断した場合。</span>
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >利用規約の規定に違反するコンテンツを本サービスに掲載した場合。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >確定・未確定を問わず売上、利益その他これに類するものを公開して、本サービス上で配信するコンテンツや各種サービスの購入を煽る場合</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span>スパム投稿、スパム行為であると当社が判断した場合。</span>
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >反社会的勢力等又はそれに準ずると当社が独自に判断した場合。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >投稿したコンテンツが不適切な内容であると当社が独自に判断した場合。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span>本サービスのサーバーに過度に負担をかける場合。</span>
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >本サービスの運営に支障が生じると当社が独自に判断した場合</span
            >
          </span>
        </li>
      </ul>
      <p class="blank-line">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >お客様が本サービスを退会された後も下記コンテンツは削除されないものとします。</span
          >
        </span>
      </p>
      <ul class="senpaiac">
        <li class="li">
          <span>
            <span>お客様ご自身の自分史</span>
          </span>
        </li>
        <li class="li">
          <span>
            <span>お客様が投稿された記事・コメント</span>
          </span>
        </li>
        <li class="li">
          <span>
            <span>お客様が投稿されたQ&A</span>
          </span>
        </li>
      </ul>
      <p class="blank-line">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="p3 p">
        <span>
          <span>本サービスについて</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >当社は事前の通知なく本サービスの運営の諸条件、サービス内容の変更ができるものとします。
            また、当社は営業上、技術上の理由等により、本サービスを終了することができるものとします。その際、当社に故意又は重過失がある場合を除き、お客様が本サービスをご利用になれなかった事により発生した、いかなる損害・損失・不利益に関して責任を負わないものとします。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="p3 p">
        <span>
          <span>サービスの変更・停止について</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >当社はシステムの稼動状態を良好に保つため、又はその他やむをえない事情が発生した場合、お客様に事前の通知なく、本サービスの内容の変更、全部又は一部サービスの停止をすることができるものとします。その際、当社に故意又は重過失がある場合を除き、お客様が本サービスをご利用になれなかった事により発生した、いかなる損害・損失・不利益に関して責任を負わないものとします。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="p3 p">
        <span>
          <span>アカウント情報の管理について</span>
        </span>
      </p>
      <ol class="senpaiac">
        <li class="li">
          <span>
            <span
              >お客様は、自己の責任において、本サービスにかかるユーザーID及びパスワード（以下「アカウント情報」といいます。）を管理及び保管するものとし、これを第三者に利用させたり、貸与、譲渡、名義変更、売買等をしてはならないものとします。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >アカウント情報の管理不十分、使用上の過誤、第三者の使用等による損害の責任はお客様が負うものとし、当社は当社の故意又は重過失による場合を除き、一切の責任を負いません。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >お客様は、アカウント情報が盗まれ、又は第三者に使用されていることが判明した場合には、直ちにその旨を当社に通知するとともに、当社からの指示に従うものとします。</span
            >
          </span>
        </li>
      </ol>
      <p class="p3 p">
        <span>
          <span>設備の負担等</span>
        </span>
      </p>
      <ol class="senpaiac">
        <li class="li">
          <span>
            <span
              >本サービスの提供を受けるために必要な、コンピューター、スマートフォン、ソフトウェアその他の機器、通信回線その他の通信環境等の準備及び維持は、お客様の費用と責任において行うものとします。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >お客様は自己の本サービスの利用環境に応じて、コンピューター・ウィルスの感染の防止、不正アクセス及び情報漏洩の防止等のセキュリティ対策を自らの費用と責任において講じるものとします。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >当社は、お客様が送受信したメッセージその他の情報を運営上一定期間保存していた場合であっても、かかる情報を保存する義務を負うものではなく、当社はいつでもこれらの情報を削除できるものとします。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >お客様は、本サービスの利用開始に際し又は本サービスの利用中に、本サイトからのダウンロードその他の方法によりソフトウェア等をお客様のコンピューター、スマートフォン等にインストールする場合には、お客様が保有する情報の消滅若しくは改変又は機器の故障、損傷等が生じないよう十分な注意を払うものとします。</span
            >
          </span>
        </li>
      </ol>
      <p class="p3">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="blank-line p">
        <span>
          <span>禁止事項について</span>
        </span>
      </p>
      <ol class="senpaiac">
        <li class="li">
          <span>
            <span
              >お客様は、本サービスの利用にあたり、以下の各号のいずれかに該当する行為をしてはなりません。</span
            >
          </span>
        </li>
      </ol>
      <ul class="senpaiac">
        <li class="li">
          <span>
            <span
              >当社、情報提供元、権利保持者、販売提携会社、広告主など第三者の著作権、商標権等の知的財産権、その他の権利又は利益を侵害する行為、又は侵害するおそれのある行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >当社、他のお客様、投稿者その他の第三者の財産、プライバシーもしくは肖像権を侵害する行為、又は侵害するおそれのある行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >当社、他のお客様、投稿者その他の第三者を差別もしくは誹謗中傷し、又は名誉もしくは信用を毀損する行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >他者に精神的もしくは経済的損害を与える行為、又は与えるおそれのある行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >面識のない異性との猥褻目的での出会いを主な目的として利用する行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span>未成年者を害する行為、又は害するおそれのある行為。</span>
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >詐欺、規制薬物の濫用、児童売買春、預貯金口座及び携帯電話の違法な売買等の犯罪に結びつく、又は結びつくおそれの高い行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >わいせつ、児童ポルノ若しくは児童虐待に相当する画像、映像、音声若しくは文書等を送信又は表示する行為、又はこれらを収録した媒体を販売する行為、又はその送信、表示、販売を想起させる広告を表示又は送信する行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span>無限連鎖講（ネズミ講）を開設し、又はこれを勧誘する行為</span>
          </span>
        </li>
        <li class="li">
          <span>
            <span>特定の宗教団体や宗教活動の勧誘行為。</span>
          </span>
        </li>
        <li class="li">
          <span>
            <span>自分以外の人物もしくは組織になりすます行為。</span>
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >本サービスの利用もしくは運営に支障を与える行為（与えるおそれのある行為を含む）。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >他者の設備等又はインターネット接続サービス用設備の利用若しくは運営に支障を与える行為、又は与えるおそれのある行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >有価証券及びデリバティブ取引に関する販売・勧誘、投資顧問契約に基づく助言、投資顧問契約や投資一任契約締結の代理・媒介、資産管理その他の金融商品取引業を行うこと（金融商品取引業者であるか否かを問わない。なお、用語の意味内容は金融商品取引法にしたがう。）</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >違法な賭博・ギャンブルを行わせ、又は違法な賭博・ギャンブルへの参加を勧誘する行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >違法行為（けん銃等の譲渡、爆発物の不正な製造、児童ポルノの提供、公文書偽造、殺人、脅迫等）を請負し、仲介し又は誘引（他人に依頼することを含む）する行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >勧誘や広告、宣伝を目的とする情報、又は社会通念上他者に著しく嫌悪感を抱かせる情報を掲載する行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >人を自殺に誘引若しくは勧誘する行為、又は第三者に危害の及ぶおそれのある自殺の手段等を紹介する等の行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >犯罪や違法行為に結びつく、又はそのおそれの高い情報や、他者を不当に誹謗中傷・侮辱したり、プライバシーを侵害したりする情報を、不特定の者をして掲載等させることを助長する行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >上記の他、法令、公序良俗に違反（売春、暴力、残虐等）する行為、サービスの運営を妨害する行為、規約や当社及び情報提供元が所属する業界団体の内部規則に違反する行為、当社及び出版社など第三者の信用を毀損、もしくは財産を侵害する行為、又は他者もしくは当社に不利益を与える行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >本サービスの利用に関して得られる情報を改ざん等する行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >本サービスを利用しての営業活動、営利を目的とした利用およびその準備を目的とした利用（但し、当社が別途個別に承認した場合は除く）。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >社会通念上他者に嫌悪感を抱かせる又はそのおそれのある情報を掲載する行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >他のお客様、投稿者その他の第三者の個人情報の収集や蓄積、又はストーキングをする行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span
              >上記いずれかの行為を助長する目的で外部からリンクを張る、又は本サービスにアクセスをする行為。</span
            >
          </span>
        </li>
        <li class="li">
          <span>
            <span>アカウントを第三者に譲渡又は貸与する行為。</span>
          </span>
        </li>
        <li class="li">
          <span>
            <span>「金融商取引法に関するポリシー」にて禁止される行為</span>
          </span>
        </li>
        <li class="li">
          <span>
            <span>その他、当社が不適切と合理的に判断する行為</span>
          </span>
        </li>
      </ul>
      <p class="blank-line">
        <span>
          <span
            >2.
            当社は、本サービスにおけるお客様による投稿、その他の情報の送信が前項各号のいずれかに該当し、又は該当するおそれがあると当社が合理的に判断した場合には、お客様に事前に通知することなく、当該情報の全部又は一部について削除、送信停止その他の措置をとることができるものとします。当社は、本項に基づき当社が行った措置に基づきお客様に生じた損害について、当社の故意又は重過失による場合を除き、一切の責任を負いません。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="p3 p">
        <span>
          <span>登録取り消しについて</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >1.
            当社は、お客様が、以下の各号のいずれかの事由に該当する場合は、事前に通知又は催告することなく、当該お客様について本サービスの利用を一時的に停止し、又はお客様としての登録を取り消すことができます。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>(1) 利用規約のいずれかの条項に違反した場合</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>(2) 登録情報に虚偽の事実があることが判明した場合</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >(3)
            当社、投稿者、他のお客様その他の第三者に損害を生じさせるおそれのある目的又は方法で本サービスを利用した、又は利用しようとした場合</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>(4) 手段の如何を問わず、本サービスの運営を妨害した場合</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >(5)
            支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >(6)
            自ら振出し、若しくは引受けた手形若しくは小切手につき、不渡りの処分を受けた場合、又は手形交換所の取引停止処分その他これに類する措置を受けたとき</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >(7)
            差押、仮差押、仮処分、強制執行又は競売の申立てがあった場合</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>(8) 租税公課の滞納処分を受けた場合</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>(9) 死亡した場合</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>(10) 「登録について」第3項各号に該当する場合</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >(11)
            その他、当社がお客様としての登録の継続を適当でないと合理的に判断した場合</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >2.
            前項各号のいずれかの事由に該当した場合、お客様は、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >3.
            お客様は、当社所定の方法で相手方に通知することにより、お客様の登録を取り消すことができます。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >4.
            当社は、本条に基づき当社が行った行為によりお客様に生じた損害について、当社の故意又は重過失による場合を除き、一切の責任を負いません。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >5.
            本条に基づきお客様の登録が取り消された場合、お客様は、当社の指示に基づき、当社から提供を受けた本サービスに関連するソフトウェア、マニュアルその他の物につき、返還、廃棄その他の処分を行うものとします。</span
          >
        </span>
      </p>
      <p class="p3">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="blank-line p">
        <span>
          <span>反社会的勢力の排除について</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >（1）当社は、お客様又は利用契約締結に関するお客様の代理人若しくは利用契約締結を媒介した者が反社会的勢力等であることが判明した場合には、お客様に対し、利用契約の解除その他の必要な措置を講ずるよう求めることができるものとします。 （2）前項に基づいて必要な措置を講ずるよう求めたにもかかわらず、お客様が正当な理由なくこれを拒否した場合、当社は催告を要せずお客様に書面で通知することにより直ちにお客様の登録を取り消すことができるものとします。 （3）前各項に定める場合を除き、当社は、お客様の取締役、監査役、従業員その他の構成員、株主、取引先、若しくは顧問その他のアドバイザーが反社会的勢力等であること、又はお客様が資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていることが判明した場合において、その解消を求める通知をお客様が受領後相当期間内にこれが解消されないときは、お客様に電子メール又は書面で通知することにより直ちにお客様の登録を取り消すことができるものとします。</span
          >
        </span>
      </p>
      <p class="p3">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="blank-line p">
        <span>
          <span>免責について</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >当社は、お客様が本サービスの利用により被った損害に関して、当社に故意又は重過失がある場合を除き、責任を負わないものとします。 また、お客様が本サービスの利用により、投稿者、他のお客様その他の第三者に対して損害等を与えた場合には、当該お客様は自己の責任において解決し、当社には一切責任を負わないものとします。  </span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >消費者契約法その他の強行法規の適用その他何らかの理由により、当社が本サービスに関してお客様に対して損害賠償責任を負う場合においても、当社の故意又は重過失による場合を除き、当社の賠償責任は、直接かつ通常の損害に限り、逸失利益、間接損害等は含まないものとし、また、損害の事由が生じた時点から遡って過去1ヶ月間にお客様から現実に受領した本サービスの対価の総額又は500円のいずれか高い金額を上限とします。 </span
          >
        </span>
      </p>
      <p class="p3 p">
        <span>
          <span>メールによる通知について</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >当社からお客様に対する通知及びご連絡は、お客様からのお申し込みの完了後に発送する「お申し込み完了通知」を含め、当社から特に他の方法を指定しない限り、すべてメールをお客様の登録したメールアドレス宛に発信することによって行うことができるものとします。当社が、お客様が登録したメールアドレス宛にメールでご通知・ご連絡を発信したにもかかわらず、当社側の過失なくしてこれがお客様に届かなかったことによりお客様が損害・損失・不利益等（損害等）を被ったとしても、当社はその損害等につき一切の責任を負わないものとします。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="p3 p">
        <span>
          <span>協議による解決について</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >本サービスのご利用に関して、利用規約又は当社の指導により解決できない問題が生じた場合には、当社と当該お客様との間で双方誠意を持って話し合い、解決するものとします。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="p3 p">
        <span>
          <span>合意管轄裁判所について</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >当社とお客様の間で、訴訟の必要が生じた場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="p3 p">
        <span>
          <span>利用規約の変更について</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >当社は、お客様に対する事前の通知をすることなく利用規約、及び、
            別紙「</span
          >
        </span>
        <span>
              プライバシーポリシー
          </span>
        <span>
          <span class="span2">」、「</span>
        </span>
        <span>
            金融商品取引法に関するポリシー
          </span>
        <span>
          <span class="span2">」、「</span>
        </span>
        <span>
            コニュニティガイドライン
          </span>
        <span>
          <span
            >」に記載された全ての内容（利用規約等）を変更することがあります。当社は、利用規約等を変更する場合には、変更の内容及び変更の効力発生時期を、当該効力発生時期までに当社所定の方法で告知するものとします。告知された効力発生時期以降にお客様が本サービスを利用した場合には、お客様は、利用規約等の変更に同意したものとみなします。</span
          >
        </span>
      </p>
      <p class="p3">
        <span>
          <span
            >最新の内容変更を本サイトで頻繁にご確認頂けますようお願致します。別途規定されていない限り、最新の利用規約がお客様の現在の全てのお取引に適用されます。</span
          >
        </span>
      </p>
      <p class="p3">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="blank-line p">
        <span>
          <span>利用規約の譲渡等</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >1.お客様は、当社の書面による事前の承諾なく、利用契約上の地位又は利用規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。</span
          >
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span
            >2.当社は本サービスにかかる事業を第三者に譲渡（事業譲渡、会社分割その他態様の如何を問わないものとします。）した場合には、当該譲渡に伴い利用契約上の地位、利用規約に基づく権利及び義務並びにお客様の登録情報その他の顧客情報を当該譲渡の譲受人に譲渡することができるものとし、お客様は、かかる譲渡につき本項において予め同意したものとします。</span
          >
        </span>
      </p>
      <p class="p3">
        <span>
          <span>&nbsp;</span>
        </span>
      </p>
      <p class="blank-line p">
        <span>
          <span>お問い合せ</span>
        </span>
      </p>
      <p class="blank-line">
        <span>
          <span>当社の利用規約に関するご質問は「</span>
        </span>
        <a
          class="a"
          href="https://www.fujisan.co.jp/pc/toushisenpai"
          target="_blank"
        >
          <span>
            <span class="span3">お問い合わせ</span>
          </span>
        </a>
        <span>
          <span class="span2">」までお願いいたします。</span>
        </span>
      </p>
    </div>
        `,
            },
        ],
    },
    {
        title: '特定商取引法に基づく表示',
        items: [
            {
                title: '特定商取引法に基づく表示',
                content: `
        <div
        style="
          position: relative;
          background-color: #f7f7f7;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          gap: 12px;
          text-align: left;
          font-size: 16px;
          color: #292a33;
        "
      >
        <div
          style="
            position: relative;
            line-height: 150%;
            display: inline-block;
            font-weight: 700;
            font-family: 'Hiragino Kaku Gothic Pro W6';
          "
        >
          特定商取引法に基づく表示
        </div>
        <div
          style="
            position: relative;
            line-height: 150%;
            display: inline-block;
            font-size: 14px;
          "
        >
          <p style="margin: 0">
            <span>
              <span>
                <span>更新日：2024/8/6</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span
                  >「特定商取引に関する法律」第11条（通信販売についての広告）に基づき以下に明示いたします。</span
                >
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p style="margin: 0; font-size: 15px">
            <span>
              <span>
                <span>サービス名</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>
                  投資の先輩
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p style="margin: 0; font-size: 15px">
            <span>
              <span>
                <span>販売事業者名</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>
                  株式会社富士山マガジンサービス
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p style="margin: 0; font-size: 15px">
            <span>
              <span>
                <span>販売事業者所在地</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>
                  東京都渋谷区南平台町16-11
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p style="margin: 0; font-size: 15px">
            <span>
              <span>
                <span>運営責任者</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>
                  佐久間勝広
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p style="margin: 0; font-size: 15px">
            <span>
              <span>
                <span>
                  電話番号・問い合わせ先
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>■0570-200-223</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>■cs@senpai.ac</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>
                  営業時間 平日10:00-17:00（土日祝日を除く）<br>メールは24時間お受けいたしますが、返信までにお時間をいただく場合がございます。あらかじめご了承ください。
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p style="margin: 0; font-size: 15px">
            <span>
              <span>
                <span>
                  商品販売価格
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>■有償プランご利用時：100円（税込）</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>■デジタルコンテンツ：コンテンツページをご確認下さい。</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>
                  本サービスで表示している商品の価格は、全て税込み価格です。<br>今後、経済情勢の変動、消費税の税率変更等の事由に基づき、当社は商品販売に係る代金を改定することができるものとします。
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p style="margin: 0; font-size: 15px">
            <span>
              <span>
                <span>
                  商品販売価格以外の費用
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>
                  インターネット接続料金その他の電気通信回線の通信に関する費用は、お客様にて、別途ご用意いただく必要があります（金額は、お客様が契約した各事業者が定める通り）。
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p style="margin: 0; font-size: 15px">
            <span>
              <span>
                <span>
                  お支払い方法
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>
                  ■クレジットカード決済
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>
                  ■App Store 決済
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>
                  ■Google Play Store決済
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p style="margin: 0; font-size: 15px">
            <span>
              <span>
                <span>
                  返金・退会等の対応
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>
                  当社所定の方法によりお客様はいつでも有償プランを解約できます。ただし、既に支払われた料金について返金（日割り計算による返金も含む）はできないものとします。<br>有償プランの解約お手続きをいただいた時点で有償プランはご利用いただけなくなります。
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p style="margin: 0; font-size: 15px">
            <span>
              <span>
                <span>
                  商品引渡時期
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>
                  必要情報（クレジットカード情報含む）をご登録いただき、決済が完了しましたら、直ちに利用が可能となります。
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p style="margin: 0; font-size: 15px">
            <span>
              <span>
                <span>
                  商品の提供期間
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>
                  ■有償プラン
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>
                  決済完了後、お申込みの日を1日目とし、1ヶ月毎の自動更新とします。当社所定の手続を行うことによりいつでも中途解約及び自動更新の停止が可能となりますが、返金は行われません。
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p style="margin: 0; font-size: 15px">
            <span>
              <span>
                <span
                  >本サービス利用のための対応機種およびソフトウェアの要件</span
                >
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>■Google Chrome 最新版</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>■Safari 最新版</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>■Microsoft Edge 最新版</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p style="margin: 0; font-size: 15px">
            <span>
              <span>
                <span>支払い時期</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>■有償プラン</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>申込み月：決済完了後、お申込みの日を1日目とし、お申込み日より1ヶ月間の月会費を申し受けます。<br>申込み月の翌月以降：お申込み日の応当する毎月暦日に、その月の月会費をお支払いただきます。 
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>■デジタルコンテンツ：商品注文時</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span
                  >※クレジットカード決済の場合、決済時に使用するクレジットカードサービスの提供事業者が定める支払日</span
                >
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>
                  ※App Store、Google Play Store決済の場合、購入代金はGoogle.Inc又はApple.Inc(その子会社を含む）が定める規定に従い請求が行われます。
                </span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>App Store決済の請求の仕組み</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <a
              style="color: #007aff"
              href="https://support.apple.com/ja-jp/HT201359"
              target="_blank"
            >
              <span>
                <span>
                  <span style="text-decoration: underline"
                    >https://support.apple.com/ja-jp/HT201359</span
                  >
                </span>
              </span>
            </a>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>Google Play Store決済の支払いについて</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <a
              style="color: #007aff"
              href="https://support.google.com/pay/answer/7644008?hl=ja"
              target="_blank"
            >
              <span>
                <span>
                  <span style="text-decoration: underline"
                    >https://support.google.com/pay/answer/7644008?hl=ja</span
                  >
                </span>
              </span>
            </a>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          
          <p style="margin: 0; font-size: 15px">
            <span>
              <span>
                <span>個人情報の取扱いについて</span>
              </span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>
                <span>個人情報の取扱については、当社サイト上「</span>
              </span>
            </span>
            <span>
                <span>
                  <span>プライバシーポリシー</span>
                </span>
              </span>
            <span>
              <span>
                <span style="color: #292a33">」をご確認ください。</span>
              </span>
            </span>
          </p>
        </div>
      </div>
        `,
            },
        ],
    },
    {
        title: '各種ポリシー',
        items: [
            {
                title: 'プライバシーポリシー',
                content: `
				<div
      style="
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 8px;
        text-align: left;
        font-size: 14px;
        color: #292a33;
        
      "
    >
      <div
        style="
          background-color: #f7f7f7;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          gap: 12px;
        "
      >
        <div
          style="
            align-self: stretch;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 12px;
          "
        >
          <div style="width: 60px; position: relative; height: 60px">
            <div
              style="
                position: absolute;
                top: 0px;
                left: 0px;
                width: 60px;
                height: 60px;
                overflow: hidden;
              "
            >
              <div
                style="
                  position: absolute;
                  height: 94.83%;
                  width: 95%;
                  top: 2.5%;
                  right: 2.5%;
                  bottom: 2.67%;
                  left: 2.5%;
                "
              >
                <div
                  style="
                    position: absolute;
                    height: 87.7%;
                    width: 100%;
                    top: 0%;
                    right: 0%;
                    bottom: 12.3%;
                    left: 0%;
                  "
                >
                  <img
                    style="
                      position: absolute;
                      height: 100%;
                      width: 100%;
                      top: 0%;
                      right: 0%;
                      bottom: 0%;
                      left: 0%;
                      max-width: 100%;
                      overflow: hidden;
                      max-height: 100%;
                    "
                    alt=""
                    src="${images_1.images.PolicyLogo}"
                  />
                </div>
              </div>
            </div>
          </div>
          <div style="flex: 1; position: relative; line-height: 150%">
            株式会社富士山マガジンサービスは、プライバシーマークを取得しています。
          </div>
        </div>
        <div
          style="
            position: relative;
            font-size: 16px;
            line-height: 150%;
            display: inline-block;
            font-weight: 700;
            font-family: 'Hiragino Kaku Gothic Pro W6';
          "
        >
          プライバシーポリシー
        </div>
        <div
          style="
            position: relative;
            line-height: 150%;
            display: inline-block;
          "
        >
          <p style="margin: 0">
            <span>
              <span
                >
                当社の主事業である雑誌定期購読販売事業を含むコミュニティサービス（以下、「コミュニティサービス等」）の運営事業を行っていく上で、「個人情報保護」は重要なテーマです。また、「個人情報（以下、個人情報の保護の関する法律第2条に定義する個人情報を意味する）」は、お客様にとっても、取り扱う当社にとっても重要な情報資産であり、確実に保護することは重要な責務であります。 したがって、当社は「個人情報保護」のための全社的な取り組みを実施し、お客様への「安心」の提供及び社会的責任の責務を果たすことを確実にいたします。
                </span
              >
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">個人情報の取得・利用・提供について</span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span
                >当社は、個人情報の取得・利用・提供に際して、その利用目的を明確にし、本人の同意を得たうえで利用目的の達成に必要な範囲内で適法かつ公正な手段によって取得・利用・提供を行います。また、当社が保有している個人情報は、同意を得ずに目的外利用、第三者への提供・開示は行いません。当社においてはこれらの取り組みを確実にするため、従業者等の教育を徹底してまいります。また、目的外利用を行わないために、適切な管理措置を講じます。</span
              >
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">法令遵守</span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span
                >当社は、個人情報に関連する法令、国が定める指針及びその他の規範を遵守します。また、当社の管理の仕組みに、これらの法令及びその他の規範を常に適合させます。</span
              >
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">個人情報の安全管理措置</span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span
                >当社は、個人情報の正確性及び安全性を確保するために、下記セキュリティ対策をはじめとする安全対策を実施し、個人情報の漏えい、滅失またはき損の防止及び是正に努めます。</span
              >
            </span>
          </p>
          <ul style="margin: 0; font-size: inherit; padding-left: 19px">
            <li style="margin-bottom: 0px">
              <span>
                <span>アクセス制御</span>
              </span>
            </li>
            <li style="margin-left: 20px;margin-bottom: 0px">
              <span>
                <span
                  >個人データを取り扱うことのできる機器及び当該機器を取り扱う従業者を明確化し、
                  個人データへの不要なアクセスを防止しています。</span
                >
              </span>
            </li>
            <li style="margin-bottom: 0px">
              <span>
                <span>アクセス者の識別と認証</span>
              </span>
            </li>
            <li style="margin-left: 20px;margin-bottom: 0px">
              <span>
                <span
                  >機器に標準装備されているユーザー制御機能（ユーザーアカウント制御）により、個人情報データベース等を取り扱う情報システムを使用する従業者を識別・認証しています。</span
                >
              </span>
            </li>
            <li style="margin-bottom: 0px">
              <span>
                <span>外部からの不正アクセス等の防止</span>
              </span>
            </li>
            <li style="margin-left: 20px;margin-bottom: 0px">
              <span>
                <span
                  >個人データを取り扱う機器等のオペレーティングシステムを最新の状態に保持しています。</span
                >
              </span>
            </li>
            <li style="margin-left: 20px;margin-bottom: 0px">
              <span>
                <span
                  >個人データを取り扱う機器等にセキュリティ対策ソフトウェア等を導入し、自動更新
                  機能等の活用により、これを最新状態としています。</span
                >
              </span>
            </li>
            <li style="margin-bottom: 0px">
              <span>
                <span>情報システムの使用に伴う漏洩等の防止</span>
              </span>
            </li>
            <li style="margin-left: 20px;margin-bottom: 0px">
              <span>
                <span
                  >メール等により個人データの含まれるファイルを送信する場合に、当該ファイルへのパスワードを設定しています。</span
                >
              </span>
            </li>
          </ul>
          <p style="margin: 0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">個人情報保護マネジメントシステムの継続的改善</span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span
                >当社は、内部監査及びマネジメントレビューの機会を通じて、個人情報保護マネジメントシステムを継続的に改善し、常に最良の状態を維持します。</span
              >
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">苦情及び相談受付け窓口</span>
            </span>
          </p>
          <p style="margin: 0;">
            <span>
              <span
                >貴殿の個人情報及び当社の個人情報保護マネジメントシステムに関するご相談及び苦情については以下までご連絡ください。<br/>適切、かつ迅速に対応させていただきます。<br/><br/>株式会社富士山マガジンサービス
                個人情報問い合わせ係<br/>TEL：0570-200-223<br/>FAX：03-5459-7073<br/>e-mail：</span
              >
            </span>
            <a
              style="color: #007aff"
              href="mailto:cs@fujisan.co.jp"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline">cs@fujisan.co.jp</span>
              </span>
            </a>
          </p>
          <p style="margin: 0">
            <span>
              <span
                >改訂：2024年4月15日<br/>株式会社富士山マガジンサービス<br/>代表取締役会長　西野伸一郎</span
              >
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span style="font-weight: 700">個人情報の取扱いについて</span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span style="font-weight: 700">１．個人情報保護管理者</span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span
                >当社は以下の個人情報保護管理者を設置し、個人情報保護管理者の責任のもと、個人情報を取得・アクセス・利用・提供・管理いたします。<br/><br/>東京都渋谷区南平台町16-11<br/>株式会社富士山マガジンサービス<br/>代表取締役会長　西野伸一郎<br/>個人情報保護管理者:
                取締役経営管理グループディレクター 佐藤鉄平</span
              >
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span style="font-weight: 700">２．利用目的</span>
            </span>
          </p>
          <p style="margin: 0">
            <span>
              <span
                >当社が取り扱う開示対象個人情報の利用目的は次のとおりです。</span
              >
            </span>
          </p>
        </div>
      </div>
      <div
        style="
          border-radius: 2px;
          background-color: #fefefe;
          border: 1px solid #ddd;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
        "
      >
        <div
          style="
            border-bottom: 1px solid #ddd;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: flex-start;
          "
        >
          <div
            style="
              border-right: 1px solid #ddd;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 8px 4px;
            "
          >
            <div style="position: relative; line-height: 150%">No</div>
          </div>
          <div
            style="
              border-right: 1px solid #ddd;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 8px 40px;
            "
          >
            <div style="position: relative; line-height: 150%">
              個人情報の種類
            </div>
          </div>
          <div
            style="
              border-right: 1px solid #ddd;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 8px 40px;
            "
          >
            <div style="position: relative; line-height: 150%">利用目的</div>
          </div>
        </div>
        <div
          style="
            width: 342px;
            border-bottom: 1px solid #ddd;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 0px 4px;
              min-width: 28px;
            "
          >
            <div style="position: relative; line-height: 150%">1</div>
          </div>
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 0px 12px;
              max-width: 178px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              当社のコミュニティサービス等をご利用の方の個人情報
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 8px 12px;
              box-sizing: border-box;
              max-width: 136px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              <p style="margin: 0">購入商品の配送のため</p>
              <p style="margin: 0">商品代金回収のため</p>
              <p style="margin: 0">
                ｅメール等による商品、サービス、キャンペーン等の広告の案内のため
              </p>
            </div>
          </div>
        </div>
        <div
          style="
            width: 342px;
            border-bottom: 1px solid #ddd;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 0px 4px;
              min-width: 28px;
            "
          >
            <div style="position: relative; line-height: 150%">2</div>
          </div>
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 0px 12px;
              max-width: 178px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              当社にお問合わせいただいた方の個人情報
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 8px 12px;
              box-sizing: border-box;
              max-width: 136px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              お問い合わせ対応、トラブル対処、オペレーター教育など応対品質向上のため
            </div>
          </div>
        </div>
        <div
          style="
            width: 342px;
            border-bottom: 1px solid #ddd;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 0px 4px;
              min-width: 28px;
            "
          >
            <div style="position: relative; line-height: 150%">3</div>
          </div>
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 0px 12px;
              max-width: 178px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              採用応募者の方の個人情報
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 8px 12px;
              box-sizing: border-box;
              max-width: 136px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              採用選考、ご連絡のため
            </div>
          </div>
        </div>
        <div
          style="
            width: 342px;
            border-bottom: 1px solid #ddd;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 0px 4px;
              min-width: 28px;
            "
          >
            <div style="position: relative; line-height: 150%">4</div>
          </div>
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 0px 12px;
              max-width: 178px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              当社の従業者の個人情報
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 8px 12px;
              box-sizing: border-box;
              max-width: 136px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              人事、総務などの雇用管理等のため
            </div>
          </div>
        </div>
        <div
          style="
            width: 342px;
            border-radius: 2px;
            overflow: hidden;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 0px 4px;
              min-width: 28px;
            "
          >
            <div style="position: relative; line-height: 150%">5</div>
          </div>
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 0px 12px;
              max-width: 178px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              パートナー（提携企業）からの委託により当社の定期購読サービス等をご利用の方の個人情報
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 8px 12px;
              box-sizing: border-box;
              max-width: 136px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              <p style="margin: 0">購入商品配送のため</p>
              <p style="margin: 0">
                提携企業及びお客様がご購入された商品の発売元企業からのｅメール等による商品、サービス、キャンペーン等の広告に関するご案内のため
              </p>
            </div>
          </div>
        </div>
      </div>
      <div style=" position: relative; height: 105px">
        <div style="position: absolute; top: 0px; left: 0px; line-height: 150%">
          ※
        </div>
        <div
          style="
            position: absolute;
            top: 0px;
            left: 11px;
            line-height: 150%;
            display: inline-block;
            width: 332px;
          "
        >
          <p style="margin: 0">
            上記の利用目的のうちNo.1～5については保有個人データ（開示対象個人情報）の利用目的であり、下記4.の開示等のご請求に対応させていただきます。
          </p>
          <p style="margin: 0">
            なお、6については、パートナー（提携企業）様にご請求いただきますようお願い致します。
          </p>
        </div>
      </div>
      <div
        style="
          
          position: relative;
          line-height: 150%;
          display: inline-block;
        "
      >
        <p style="margin: 0">
          <span>
            <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">３．個人情報の第三者提供について</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >当社は、取得した個人情報を適切に管理し､あらかじめ本人の同意を得ることなく第三者に提供することはありません。ただし、次の場合は除きます。</span
            >
          </span>
        </p>
        <ul style="margin: 0; font-size: inherit; padding-left: 19px">
          <li style="margin-bottom: 0px">
            <span>
              <span>法令に基づく場合</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span
                >人の生命､身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき。</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span
                >公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難である場合。</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span
                >国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき。</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span
                >上記２．の利用目的を実施するために守秘義務を結んだ企業に、業務の一部として個人情報の取扱いを委託・提供する場合、その業務に必要な範囲で委託・提供先企業に個人情報を開示することがあります。<br/>委託・提供先企業は具体的には以下のような企業ですが、これらに限りません。</span
              >
            </span>
          </li>
          <li style="margin-left: 20px;margin-bottom: 0px">
            <span>
              <span
                >委託先：カスタマーサポート支援会社
                、クレジットカード決済などの決済代行・料金回収会社、広告配信サービス会社</span
              >
            </span>
          </li>
          <li style="margin-left: 20px;margin-bottom: 0px">
            <span>
              <span
                >提供先：出版社、出版物発売元、卸売会社、販売店など商品の供給者、梱包会社、配送会社、新聞販売店などの梱包・配送・配達会社</span
              >
            </span>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">４．開示対象個人情報の「開示」「訂正」等の請求について</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >当社は、本人から、開示対象個人情報について利用目的の通知を求められた場合には、遅滞なくこれに応じます。ただし、以下①～④のいずれかに該当する場合は、利用目的の通知を行なうことはできません。そのときは、本人に遅滞無くその旨を通知するとともに、理由を説明させていただきます。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >①利用目的を本人に通知し、又は公表することによって本人又は第三者の生命、身体、財産その他の権利利益を害するおそれがある場合<br/>②利用目的を本人に通知し、又は公表することによって当該事業者の権利又は正当な利益を害するおそれがある場合<br/>③国の機関又は地方公共団体が法令の定める事務を遂行することに対して協力する必要がある場合であって、利用目的を本人に通知し、又は公表することによって当該事務の遂行に支障を及ぼすおそれがあるとき<br/>④開示対象個人情報の利用目的が明らかな場合<br/><br/><br/></span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >開示対象個人情報については、保有個人データの本人またはその代理人からの利用目的の通知、開示、変更等（内容の訂正、追加または削除）、利用停止等（「利用の停止または消去」「第三者への提供の停止」）の求めに対応させていただいております。
              当社顧客の皆様の個人情報は「マイページ」にログインしていただくことで、訂正、追加、変更を行っていただくことが出来ます。マイページをご利用いただけない方、その他の方につきましては、下記Aをご覧ください。
              また、ご登録いただいた個人情報のうち、市町村などの名称および郵便番号、金融機関の名称あるいはクレジットカードの有効期限など、商品のお届けやご請求を行う上で支障がある情報に変更があった場合には、当社が登録情報を変更させていただく場合があります。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >A.開示等の求めの申し出先、提出していただく書面等
              開示等の求めは、電話又は電子メールにて下記までお申し付けください。開示等の求めに際して提出していただく書面等については、その際にご案内いたします。<br/><br/>■電話による場合<br/>TEL:0570-200-223<br/>株式会社富士山マガジンサービス　個人情報問い合わせ係<br/>受付時間：10:00～17:00（土、日、祝、年末年始休業）<br/><br/>■電子メールによる場合<br/>e-mail：</span
            >
          </span>
          <a
            style="color: #007aff"
            href="mailto:cs@fujisan.co.jp"
            target="_blank"
          >
            <span>
              <span style="text-decoration: underline">cs@fujisan.co.jp</span>
            </span>
          </a>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >B.開示等の対応に際して、以下記載の項目のうち2項目以上での本人確認を実施させていただきます。</span
            >
          </span>
        </p>
        <ul style="margin: 0; font-size: inherit; padding-left: 19px">
          <li style="margin-bottom: 0px">
            <span>
              <span
                >商品を購入された個人のお客様：氏名、住所、電話番号、顧客番号、メールアドレス</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span
                >商品を購入された法人のお客様：氏名、会社名、部署名、会社住所、電話番号、顧客番号、メールアドレス</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>採用に応募された方：氏名、住所、所属学校（会社）名</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>お取引先様：会社名、部署名、氏名、住所</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>株主様：氏名、住所、（会社名）</span>
            </span>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span
              >C.代理人様による開示等のご請求<br/>開示等のご請求をすることについて代理人に委任する場合は、前項の書類に加えて、下記書類をご同封ください。</span
            >
          </span>
        </p>
        <ol style="margin: 0; font-size: inherit; padding-left: 19px">
          <li style="margin-bottom: 0px">
            <span>
              <span
                >委任状<br/>ご本人様が委任状に捺印し、捺印した印鑑の印鑑登録証明書を添付してください。<br/>代理人様が親権者などの法定代理人の場合は、委任状に代えて、ご本人様との関係がわかる戸籍謄本もしくは抄本、または住民票をご提出いただくことも可能です。</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span
                >代理人本人であることを確認するための書類<br/>下記書類のうち、いずれかを同封してください。（本籍地を塗りつぶしたものをご用意下さい。）<br/>・運転免許証の写し<br/>・住民票の写し<br/>・健康保険証の被保険者証の写し</span
              >
            </span>
          </li>
        </ol>
        <p style="margin: 0">
          <span>
            <span>D.手数料について</span>
          </span>
        </p>
        <ol style="margin: 0; font-size: inherit; padding-left: 19px">
          <li style="margin-bottom: 0px">
            <span>
              <span
                >利用目的の通知、開示対象個人情報の開示請求については、1回の申請ごとに手数料、郵送料が必要です。<br/>郵送料：774円（内訳：定型84円、書留480円、本人限定受取郵便210円)<br/>(2023年10月1日現在)<br/>※上記郵送料は国内郵便の場合の費用です。国外への郵送の場合は、実費をご負担いただきます。</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span
                >手数料等の支払方法<br/>費用のお支払方法は、郵送料分の郵便定額小為替を申請書類に同封してください。<br/>(郵便局にお支払いいただく手数料は申請者のご負担です。また、郵便定額小為替は無記名でお願いします。)
                なお、郵送料は郵便定額小為替に代えて同額分の切手でお支払いいただくこともできます。</span
              >
            </span>
          </li>
        </ol>
        <p style="margin: 0">
          <span>
            <span
              >E.開示等の求めに対する回答方法<br/>申請者の申請書面記載宛に書面（eメール含む）によって回答いたします。書面以外での方法による回答をご希望される方は、手続き時にその旨ご連絡ください。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >F.非開示事由について<br/>以下の(1)～(7)に該当する場合は、非開示とさせていただきます。非開示を決定した場合は、その旨、理由を付記して通知いたします。<br/><br/>(1)申請書に記載されている住所、本人確認のための書類に記載されている住所、当社に登録されている住所が一致しないときなど本人が確認できない場合<br/>(2)代理人による申請に際して､代理権が確認できない場合<br/>(3)所定の申請書類に不備があった場合<br/>(4)開示の求めの対象が開示対象個人情報に該当しない場合<br/>(5)本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合<br/>(6)当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合<br/>(7)他の法令に違反することとなる場合</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">５．苦情及び相談窓口</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >当社は、ご提出いただいた個人情報に関する苦情、相談、及びその他のお問い合わせに、適切、かつ迅速に対応致します。<br/>ご提出いただいた個人情報に関する苦情、相談は、電話又は電子メールにて下記までお申し付けください。<br/><br/>■電話による場合<br/>TEL:0570-200-223<br/>株式会社富士山マガジンサービス　個人情報問い合わせ係<br/>受付時間：10:00～17:00（土、日、祝、年末年始休業）<br/><br/>■電子メールによる場合<br/>e-mail：</span
            >
          </span>
          <a
            style="color: #007aff"
            href="mailto:cs@fujisan.co.jp"
            target="_blank"
          >
            <span>
              <span style="text-decoration: underline">cs@fujisan.co.jp</span>
            </span>
          </a>
        </p>
        <p style="margin: 0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">６．認定個人情報保護団体の名称及び、苦情の解決の申出先</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >認定個人情報保護団体の名称：一般財団法人日本情報経済社会推進協会<br/>苦情の解決の申出先：認定個人情報保護団体事務局<br/>住所：〒106-0032　東京都港区六本木1-9-9　六本木ファーストビル内<br/>電話番号：03-5860-7565、0120-700-779<br/>※当社の商品・サービスに関する問合せ先ではございません</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';"
              >７．個人関連情報をパーソナルデータとして取得することについて</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >（１）
              パーソナルデータとは<br/>パーソナルデータとは、インターネットやウェブサイト上で接続している端末やブラウザー等を判別するためのクッキー（Cookie）情報、ウェブビーコン、IPアドレスの取得情報（以下、「クッキー等」といいます。）をいいます。個人情報には該当しませんが、個人に関係する情報（特定の個人を識別できない情報）を意味します。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >クッキー（Cookie）について<br/>クッキー（Cookie）
              とは、ウェブサイト側のサーバーから、お客様側のウェブブラウザに対して送信される英数字からなる情報を、お客様のコンピュータ（またはスマートフォン、タブレットなどのインターネットへ接続可能な機器）内に記憶させておく機能です。アクセス情報の集計のほか、お客様ごとに遷移される画面の流れを制御する、メッセージを変更して表示する等のサイトサービスのためにも使用されます。これによって、例えば、お客様が再度ウェブサイトを訪れた際、お客様を識別して、ログインのために必要なIDやパスワード等の設定状況等を自動で再現することが可能になります。
              クッキーを無効にされますと、当社のサービスを一部または全部ご利用いただくことができませんので、あらかじめご了承下さい。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >ウェブビーコンについて<br/>ウェブビーコンとは、ウェブページや電子メールに埋め込まれた小さな画像ファイルです。お客様が閲覧するページや、受信する広告メールの中には、ウェブビーコンを使用してアクセス状況を調べているものがあり、ウェブサイト側で訪問の有無や訪問回数等のデータを把握することができます。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >アクセス情報（ログ）について<br/>ウェブサーバーは、サイトへのアクセス状況を記録するためにアクセスログを取得しています。お客様が検索したページや、閲覧した商品の行動履歴等のアクセスログには、お客様のIPアドレス、ブラウザー情報、プロバイダ情報、参照ページ、コンピュータ情報、アクセス時間等が含まれます。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >（２） ウェブサイトでの情報の取扱いについて（行動履歴等）<br/>ア.
              当社は、お客様からパーソナルデータを取得し、下記のために利用します。</span
            >
          </span>
        </p>
        <ul style="margin: 0; font-size: inherit; padding-left: 19px">
          <li style="margin-bottom: 0px">
            <span>
              <span
                >商品、サービス、ウェブサイトなどの内容をお客さまによりご満足いただけるよう改善するため。</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span
                >商品、サービス、ウェブサイトなどの内容をお客さまに合わせてカスタマイズするため。</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>新しい商品、サービス、ウェブサイトを提供するため 。</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>最適な販売促進を実施するための広告活動のため。</span>
            </span>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span
              >イ.
              当社は、当社の取引先よりパーソナルデータを取得し、お客様情報と紐づけたうえで、当社および当社グループ会社のマーケティング活動、お客様に最適な販売促進を実施するための広告活動のために利用します。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >ウ.
              当社では、第三者が提供する訪問者分析のためのサービスの利用および広告の配信をするために、当該第三者のクッキーも発信する場合があります。また、当社では統計や広告の効果測定のために、メールに記載されたURL等をユーザーがクリックしたことによりユーザーの行動履歴を取得したり、画像データに同様の仕組みを持たせることにより開封履歴を取得することがあります。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >（３）
              当社で利用する主な広告配信サービス<br/>当社が利用する主な広告サービスは次の通りであり、外部事業者の名称、外部事業者に送信される利用者情報の内容、サービス名等は以下の通りで、広告配信の目的で提供されます。各サービスで取得される情報は、単体では特定の個人を識別できない情報で、取得された情報の管理は、当社においては当社、各社においてはそれぞれ各社のプライバシーポリシーに基づき管理されます。広告配信等が不要な場合には、各社のサービスごとにオプトアウトすることができます。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>■ヤフー株式会社<br/>　送信される利用者情報：</span>
          </span>
        </p>
        <ul style="margin: 0; font-size: inherit; padding-left: 19px">
          <li style="margin-bottom: 0px">
            <span>
              <span>Yahoo! JAPAN が利用者を特定するための識別子</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>クッキーなどデバイスに記録されている識別子</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span
                >IPアドレス（位置情報や回線種別、アクセス元の企業や組織の推定に用いられます。）</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>閲覧したサイトのURLやアプリの画面名</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>閲覧したサイトやアプリのタイトル</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>当社訪問の直前に閲覧したサイトのURL</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>閲覧日時（滞在時間などの算出に用いられます。）</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>ウェブブラウザやデバイスの種類、バージョン</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>デバイスの画面サイズ等の閲覧環境の情報</span>
            </span>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span>　サービス名：Yahoo! 広告</span>
          </span>
        </p>
        <ul
          style="
            margin: 0;
            font-size: inherit;
            padding-left: 19px;
            color: #007aff;
          "
        >
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://privacy.yahoo.co.jp/"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Yahoo! JAPANが提供するサービスのプライバシーポリシー</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://btoptout.yahoo.co.jp/optout/index.html"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Yahoo! JAPAN広告からのオプトアウト</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://privacy.yahoo.co.jp/glossary/cookies.html"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline">クッキーポリシー</span>
              </span>
            </a>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span>■Google LLC<br/>　送信される利用者情報：</span>
          </span>
        </p>
        <ul style="margin: 0; font-size: inherit; padding-left: 19px">
          <li style="margin-bottom: 0px">
            <span>
              <span>クッキーなどデバイスに記録されている識別子</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span
                >IPアドレス（位置情報や回線種別、アクセス元の企業や組織の推定に用いられます。）</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>閲覧したサイトのURLやアプリの画面名</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>閲覧したサイトやアプリのタイトル</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>当社訪問の直前に閲覧したサイトのURL</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>閲覧日時（滞在時間などの算出に用いられます。）</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>ウェブブラウザやデバイスの種類、バージョン</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>デバイスの画面サイズ等の閲覧環境の情報</span>
            </span>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span>　サービス名：Google広告</span>
          </span>
        </p>
        <ul
          style="
            margin: 0;
            font-size: inherit;
            padding-left: 19px;
            color: #007aff;
          "
        >
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://policies.google.com/technologies/ads"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Googleが提供するサービスのプライバシーポリシー</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://adssettings.google.com/anonymous?hl=ja"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Google広告からのオプトアウト</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://policies.google.com/technologies/cookies?hl=ja#types-of-cookies"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline">クッキーポリシー</span>
              </span>
            </a>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span>■Criteo 株式会社<br/>　送信される利用者情報：</span>
          </span>
        </p>
        <ul style="margin: 0; font-size: inherit; padding-left: 19px">
          <li style="margin-bottom: 0px">
            <span>
              <span>クッキーなどデバイスに記録されている識別子</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span
                >IPアドレス（位置情報や回線種別、アクセス元の企業や組織の推定に用いられます。）</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>閲覧したサイトのURLやアプリの画面名</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>閲覧したサイトやアプリのタイトル</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>当社訪問の直前に閲覧したサイトのURL</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>閲覧日時（滞在時間などの算出に用いられます。）</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>ウェブブラウザやデバイスの種類、バージョン</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>デバイスの画面サイズ等の閲覧環境の情報</span>
            </span>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span>　サービス名：Criteo</span>
          </span>
        </p>
        <ul
          style="
            margin: 0;
            font-size: inherit;
            padding-left: 19px;
            color: #007aff;
          "
        >
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://www.criteo.com/jp/privacy/"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Criteoが提供するサービスのプライバシーポリシー</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://www.criteo.com/jp/privacy/"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Criteo広告からのオプトアウト</span
                >
              </span>
            </a>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span
              >（４）
              当社で利用する主なウェブサイトアクセス情報の収集・分析サービス<br/>当社は、クッキー等の技術を利用し、ウェブサイトを閲覧したユーザーのアクセス情報を統計的に収集・分析することができるサービスを利用しており、外部事業者の名称、外部事業者に送信される利用者情報の内容、サービス名等は以下の通りです。収集した情報は当社の事業におけるサービス改善のための分析や広告配信などに利用します。なお、このアクセスに関する情報は匿名で収集されており、個人を特定するものではありません。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>■Google LLC<br/>　送信される利用者情報：</span>
          </span>
        </p>
        <ul style="margin: 0; font-size: inherit; padding-left: 19px">
          <li style="margin-bottom: 0px">
            <span>
              <span>クッキーなどデバイスに記録されている識別子</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span
                >IPアドレス（位置情報や回線種別、アクセス元の企業や組織の推定に用いられます。）</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>閲覧したサイトのURLやアプリの画面名</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>閲覧したサイトやアプリのタイトル</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>当社訪問の直前に閲覧したサイトのURL</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>閲覧日時（滞在時間などの算出に用いられます。）</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>ウェブブラウザやデバイスの種類、バージョン</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>デバイスの画面サイズ等の閲覧環境の情報</span>
            </span>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span>　サービス名：Google Analytics</span>
          </span>
        </p>
        <ul
          style="
            margin: 0;
            font-size: inherit;
            padding-left: 19px;
            color: #007aff;
          "
        >
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://policies.google.com/technologies/partner-sites?hl=ja"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Googleが提供するサービスでのクッキーによる情報収集や情報の取り扱いについて</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://policies.google.com/privacy?hl=ja"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Googleが提供するサービスのプライバシーポリシー</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://tools.google.com/dlpage/gaoptout"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Google Analyticsからのオプトアウト</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://policies.google.com/technologies/cookies?hl=ja"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >GoogleによるCookieの利用方法</span
                >
              </span>
            </a>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span>■Microsoft Corporation<br/>　送信される利用者情報：</span>
          </span>
        </p>
        <ul style="margin: 0; font-size: inherit; padding-left: 19px">
          <li style="margin-bottom: 0px">
            <span>
              <span>クッキーなどデバイスに記録されている識別子</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>マウスの操作や画面タップなどの画面操作情報</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span
                >IPアドレス（位置情報や回線種別、アクセス元の企業や組織の推定に用いられます。）</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>閲覧したサイトのURLやアプリの画面名</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>閲覧したサイトやアプリのタイトル</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>当社訪問の直前に閲覧したサイトのURL</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>閲覧日時（滞在時間などの算出に用いられます。）</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>ウェブブラウザやデバイスの種類、バージョン</span>
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>デバイスの画面サイズ等の閲覧環境の情報</span>
            </span>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span>　サービス名：Clarity<br/><br/></span>
          </span>
        </p>
        <ul
          style="
            margin: 0;
            font-size: inherit;
            padding-left: 19px;
            color: #007aff;
          "
        >
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://clarity.microsoft.com/terms"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Microsoft Clarity –Terms of Use</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://privacy.microsoft.com/ja-jp/privacystatement"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Microsoft プライバシーステートメント</span
                >
              </span>
            </a>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span
              >（５）
              管理方法<br/>お客様は、(3)で記載の各サービスにおけるオプトアウト措置を利用するほか、ご使用のウェブブラウザで全てまたは一部のクッキー等を拒否するように設定することができます。クッキー等の設定に関する具体的な方法については、ウェブブラウザのヘルプメニュー等をご確認ください。なお、クッキー等を拒否された場合は、当社サービスのご利用ができない場合があります。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">8．個人情報の突合による広告配信等について</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >当社は、第三者（当社と契約を締結した提携会社）から受託したお客様の個人情報を、当社が管理するお客様の個人情報と突合・分析して利用します。<br/>例えば、お客様に関する広告識別子、メールアドレス、電話番号等の個人情報を第三者より受託し、当社が管理する広告識別子等およびその他の個人情報と突合・分析することで、よりお客様にカスタマイズした広告配信が行えるようになります。<br/>また、第三者から受託したお客様の個人情報を当社が管理するお客様の個人情報と突合・分析し、当該第三者によるマーケティングやサービス改善・開発等の目的のために、お客様個人を特定できないような形式の情報に加工したうえで、当該第三者に提供することがあります。<br/>また、当社は、当社が管理するお客様の個人情報を、広告配信等の目的で、第三者（私たちと契約を締結した広告配信サービス等を提供する提携会社）に提供することがあります。<br/>例えば、当社が管理する広告識別子、メールアドレス、電話番号等の個人情報を、お客様に対する広告配信目的で当該第三者に提供し、当該第三者が管理する広告識別子等およびその他の個人情報または個人関連情報と突合・分析することで、よりお客様にカスタマイズした広告配信が行えるようになります。<br/>この場合、当該第三者は、当社から依頼された広告配信のために、お客様の個人情報を利用します。<br/>なお、当社は、当社が管理するお客様の広告識別子等の個人情報を、広告成果の確認やポイントの付与等の目的で、広告出稿者（広告主）を含む第三者に提供し、当該第三者は、自ら管理する広告識別子等およびその他の個人情報または個人関連情報と紐づけて、条件達成情報等とともに当社に提供することがあります。<br/>当社は、当該提供を受けた情報を私たちが管理する個人情報と紐づけることで、お客様の広告成果の確認やポイントの付与等のために利用します。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">9．個人関連情報を個人データとして取得することについて</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >当社は、氏名等のお客様を特定する情報を保有しない第三者から、識別子や行動履歴など、お客様に関連する情報（個人関連情報）の提供を受け、当該情報を私たちが管理するお客様の個人情報と紐づけることで個人情報として取得し、別途の目的が示されている場合を除き、上記「2.
              利用目的」でご説明した目的にしたがって、当該情報を利用することがあります。<br/>具体的には、Cookie等、モバイル広告識別子、メールアドレスや電話番号（不可逆的な変換処理がなされたものを含みます。）、広告の閲覧回数等の広告配信関連ログ、ウェブサイトの閲覧履歴や検索履歴、実店舗でのショッピングを含む購買履歴、位置情報その他の行動履歴、TV視聴関連ログ等を取得し、当社が管理する個人情報と紐づけて利用する場合があります。この場合は、適用法令に従い、個人情報として適切に取り扱います。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">顧客個人情報の取扱いに関する同意文</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >当社サイトをご利用いただく際には、以下の顧客個人情報の取扱いに関して同意いただくことになります。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">１．顧客個人情報の利用目的</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>顧客個人情報の利用目的は、以下のとおりです。</span>
          </span>
        </p>
      </div>
      <div
        style="
        width: 100%;
          border-radius: 2px;
          background-color: #fefefe;
          border: 1px solid #ddd;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
        "
      >
        <div
          style="
            border-bottom: 1px solid #ddd;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: flex-start;
          "
        >
          <div
            style="
              border-right: 1px solid #ddd;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 8px 4px;
            "
          >
            <div style="position: relative; line-height: 150%">No</div>
          </div>
          <div
            style="
              border-right: 1px solid #ddd;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 8px 40px;
            "
          >
            <div style="position: relative; line-height: 150%">
              個人情報の種類
            </div>
          </div>
          <div
            style="
              border-right: 1px solid #ddd;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 8px 40px;
            "
          >
            <div style="position: relative; line-height: 150%">利用目的</div>
          </div>
        </div>
        <div
          style="
            width: 342px;
            border-bottom: 1px solid #ddd;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 0px 4px;
              min-width: 28px;
            "
          >
            <div style="position: relative; line-height: 150%">1</div>
          </div>
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 0px 12px;
              max-width: 178px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              当社のコミュニティサービス等をご利用の方の個人情報
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 8px 12px;
              box-sizing: border-box;
              max-width: 136px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              <p style="margin: 0">購入商品の配送のため</p>
              <p style="margin: 0">商品代金回収のため</p>
              <p style="margin: 0">
                ｅメール等による商品、サービス、キャンペーン等の広告の案内のため
              </p>
              <p style="margin: 0">
                個人が特定できない形で取得した閲覧履歴や購買履歴等の情報を分析して、趣味・嗜好に応じた新商品・サービスに関する広告のため
              </p>
            </div>
          </div>
        </div>
        <div
          style="
            width: 342px;
            border-bottom: 1px solid #ddd;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 0px 4px;
              min-width: 28px;
            "
          >
            <div style="position: relative; line-height: 150%">2</div>
          </div>
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 0px 12px;
              max-width: 178px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              当社にお問合わせいただいた方の個人情報
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 8px 12px;
              box-sizing: border-box;
              max-width: 136px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              お問い合わせ対応、トラブル対処、オペレーター教育など応対品質向上のため
            </div>
          </div>
        </div>
        <div
          style="
            width: 342px;
            border-bottom: 1px solid #ddd;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 0px 4px;
              min-width: 28px;
            "
          >
            <div style="position: relative; line-height: 150%">3</div>
          </div>
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 0px 12px;
              max-width: 178px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              採用応募者の方の個人情報
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 8px 12px;
              box-sizing: border-box;
              max-width: 136px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              採用選考、ご連絡のため
            </div>
          </div>
        </div>
        <div
          style="
            width: 342px;
            border-bottom: 1px solid #ddd;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 0px 4px;
              min-width: 28px;
            "
          >
            <div style="position: relative; line-height: 150%">4</div>
          </div>
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 0px 12px;
              max-width: 178px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              当社の従業者の個人情報
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 8px 12px;
              box-sizing: border-box;
              max-width: 136px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              人事、総務などの雇用管理等のため
            </div>
          </div>
        </div>
        <div
          style="
            width: 342px;
            border-radius: 2px;
            overflow: hidden;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 0px 4px;
              min-width: 28px;
            "
          >
            <div style="position: relative; line-height: 150%">5</div>
          </div>
          <div
            style="
              align-self: stretch;
              border-right: 1px solid #ddd;
              box-sizing: border-box;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 0px 12px;
              max-width: 178px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              パートナー（提携企業）からの委託により当社の定期購読サービス等をご利用の方の個人情報
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 8px 12px;
              box-sizing: border-box;
              max-width: 136px;
            "
          >
            <div style="flex: 1; position: relative; line-height: 150%">
              <p style="margin: 0">購入商品配送のため</p>
              <p style="margin: 0">
                提携企業及びお客様がご購入された商品の発売元企業からのｅメール等による商品、サービス、キャンペーン等の広告に関するご案内のため
              </p>
            </div>
          </div>
        </div>
      </div>
      <div style=" position: relative; height: 105px">
        <div style="position: absolute; top: 0px; left: 0px; line-height: 150%">
          ※
        </div>
        <div
          style="
            position: absolute;
            top: 0px;
            left: 11px;
            line-height: 150%;
            display: inline-block;
            width: 332px;
          "
        >
          <p style="margin: 0">
            上記の利用目的のうちNo.1～4については保有個人データ（開示対象個人情報）の利用目的であり、下記4.の開示等のご請求に対応させていただきます。
          </p>
          <p style="margin: 0">
            なお、5については、パートナー（提携企業）様にご請求いただきますようお願い致します。
          </p>
        </div>
      </div>
      <div
        style="
          
          position: relative;
          line-height: 150%;
          display: inline-block;
        "
      >
        <p style="margin: 0">
          <span>
            <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">２．顧客個人情報の提供</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>今回ご収集させていただく「個人情報」は、以下の理由</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >で第三者に提供させていただきます。<br/><br/>(1)
              提供先：お客様が購入した商品の発売元企業、警察、警備会社<br/>(2)
              提供の目的：購入商品配送のため、各種サービスの案内のため、施設管理及び保安上の目的のため<br/>(3)
              提供する個人情報の項目：郵便番号、住所、氏名、電話番号、メールアドレス、購入商品名、期間、ビデオカメラによる映像、音声データ、個人を特定できない形でのユーザーが閲覧したページや広告の履歴、検索キーワード、利用時間帯、ウェブサイトの利用方法、利用環境（利用に際しての各種設定情報なども含む）、ユーザーのIPアドレスおよびそれに割り当てられた組織名、第三者企業が発行する匿名ID、アプリ内ユニークID、位置情報、Cookie情報<br/>(4)
              提供の手段又は方法：提供先による該当情報のファイルダウンロード、映像、音声データファイルの提供<br/>(5)
              個人情報の取扱いに関する契約の有無：無</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">３．顧客個人情報の外部委託</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >今回取得させていただく顧客個人情報は、以下の業務処理のため、当社と契約を締結している協力会社に委託させていただきます。<br/><br/>(1)委託先：1.倉庫会社、運送会社等　2.決済代行会社　3.広告配信代行会社<br/>(2)委託処理の内容：1.購入商品配送のため　2.決済代行業務のため　3.広告配信業務のため</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">４．取得させていただく内容について</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >今回取得させていただく顧客個人情報のうち、必須項目は以下のとおりです。</span
            >
          </span>
        </p>
        <ul style="margin: 0; font-size: inherit; padding-left: 19px">
          <li style="margin-bottom: 0px">
            <span>
              <span
                >個人顧客の場合：郵便番号、住所、氏名、電話番号、生年月日、性別、メールアドレス、パスワード、電話応対による音声データ、個人を特定できない形でのユーザーが閲覧したページや広告の履歴、検索キーワード、利用時間帯、ウェブサイトの利用方法、利用環境（利用に際しての各種設定情報なども含む）、ユーザーのIPアドレスおよびそれに割り当てられた組織名、第三者企業が発行する匿名ID、アプリ内ユニークID、位置情報、Cookie情報</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span
                >法人顧客の場合：郵便番号、住所、会社名、氏名、電話番号、担当者名、メールアドレス、パスワード、電話応対による音声データ、個人を特定できない形でのユーザーが閲覧したページや広告の履歴、検索キーワード、利用時間帯、ウェブサイトの利用方法、利用環境（利用に際しての各種設定情報なども含む）、ユーザーのIPアドレスおよびそれに割り当てられた組織名、第三者企業が発行する匿名ID、アプリ内ユニークID、位置情報、Cookie情報</span
              >
            </span>
          </li>
          <li style="margin-bottom: 0px">
            <span>
              <span>来訪顧客の場合：映像、音声データ</span>
            </span>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span
              >上記項目および上記項目以外の個人情報を入力しなかった場合、サービスのご提供ができないことがございます。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">５．顧客個人情報に関する開示・訂正・削除について</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >今回収集させていただく顧客個人情報に関して開示するよう請求することができます。また万一登録内容が不正確または誤りであることが判明した場合には、当社は速やかに訂正または削除に応じさせていただきます。<br/>当社が当該情報を利用、提供している場合であっても、申込者から中止の申し出があった場合は、それ以降当社での利用、他者への提供を中止する措置をとります。<br/>ご自身の個人情報は「マイページ」にログインしていただくことで、訂正、追加、変更を行っていただくことが出来ます。<br/>個人情報の開示・削除のお問合せや、利用・提供中止の申出等に関しましては、以下にご連絡ください。<br/><br/>株式会社富士山マガジンサービス
              カスタマーサポート係<br/>TEL：0570-200-223
              FAX：03-5459-7073<br/>e-mail：</span
            >
          </span>
          <a
            style="color: #007aff"
            href="mailto:cs@fujisan.co.jp"
            target="_blank"
          >
            <span>
              <span style="text-decoration: underline">cs@fujisan.co.jp</span>
            </span>
          </a>
        </p>
        <p style="margin: 0; font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">
          <span>
            <span
              >なお、利用者がアカウントを削除した場合であっても個人情報を含まない、利用者の自分史、投稿した記事、Q&Aコンテンツは削除されずに残ります。</span
            >
          </span>
        </p>
        <p style="margin: 0;font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">
          <span>
            <span
              >Q&Aコンテンツはアカウントが有効であっても訂正や削除は受け付けておりません。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >また、利用者は、個人を特定しない形での履歴情報および特性情報の利用を拒否することができます。第三者企業が発行するCookie及び匿名ID・アプリ内ユニークIDについて、Cookie及び匿名ID・アプリ内ユニークIDを無効にしたい場合の手続きについては、下記にご案内したページ等をご確認下さい。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>■ヤフー株式会社<br/>　サービス名：Yahoo! 広告</span>
          </span>
        </p>
        <ul
          style="
            margin: 0;
            font-size: inherit;
            padding-left: 19px;
            color: #007aff;
          "
        >
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://privacy.yahoo.co.jp/"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Yahoo! JAPANが提供するサービスのプライバシーポリシー</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://btoptout.yahoo.co.jp/optout/index.html"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Yahoo! JAPAN広告からのオプトアウト</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://privacy.yahoo.co.jp/glossary/cookies.html"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline">クッキーポリシー</span>
              </span>
            </a>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span>■Google LLC<br/>　サービス名：Google広告</span>
          </span>
        </p>
        <ul
          style="
            margin: 0;
            font-size: inherit;
            padding-left: 19px;
            color: #007aff;
          "
        >
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://policies.google.com/technologies/ads"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Googleが提供するサービスのプライバシーポリシー</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://adssettings.google.com/anonymous?hl=ja"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Google広告からのオプトアウト</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://policies.google.com/technologies/cookies?hl=ja#types-of-cookies"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline">クッキーポリシー</span>
              </span>
            </a>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span>　サービス名：Google Analytics</span>
          </span>
        </p>
        <ul
          style="
            margin: 0;
            font-size: inherit;
            padding-left: 19px;
            color: #007aff;
          "
        >
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://policies.google.com/technologies/partner-sites?hl=ja"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Googleが提供するサービスでのクッキーによる情報収集や情報の取り扱いについて</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://policies.google.com/privacy?hl=ja"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Googleが提供するサービスのプライバシーポリシー</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://tools.google.com/dlpage/gaoptout"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Google Analyticsからのオプトアウト</span
                >
              </span>
            </a>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span>■Criteo 株式会社<br/>　サービス名：Criteo</span>
          </span>
        </p>
        <ul
          style="
            margin: 0;
            font-size: inherit;
            padding-left: 19px;
            color: #007aff;
          "
        >
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://www.criteo.com/jp/privacy/"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Criteoが提供するサービスのプライバシーポリシー</span
                >
              </span>
            </a>
          </li>
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://www.criteo.com/jp/privacy/"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Criteo広告からのオプトアウト</span
                >
              </span>
            </a>
          </li>
        </ul>
        <p style="margin: 0">
          <span>
            <span>■Microsoft Corporation<br/>　サービス名：Clarity</span>
          </span>
        </p>
        <ul
          style="
            margin: 0;
            font-size: inherit;
            padding-left: 19px;
            color: #007aff;
          "
        >
          <li style="margin-bottom: 0px">
            <a
              style="color: inherit"
              href="https://clarity.microsoft.com/terms"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Microsoft Clarity –Terms of Use</span
                >
              </span>
            </a>
          </li>
          <li>
            <a
              style="color: inherit"
              href="https://privacy.microsoft.com/ja-jp/privacystatement"
              target="_blank"
            >
              <span>
                <span style="text-decoration: underline"
                  >Microsoft プライバシーステートメント</span
                >
              </span>
            </a>
          </li>
        </ul>
      </div>
      <div
        style="
          
          position: relative;
          line-height: 150%;
          display: inline-block;
        "
      >
        <p style="margin: 0; font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">６．当社の個人情報保護管理者</p>
        <p style="margin: 0">当社の個人情報保護管理者は、以下のとおりです。</p>
        <p style="margin: 0">&nbsp;</p>
        <p style="margin: 0">氏名：佐藤鉄平</p>
        <p style="margin: 0">職名：取締役経営管理グループディレクター</p>
        <p style="margin: 0">TEL：0570-200-223</p>
      </div>
    </div>
				`,
            },
            // 	{
            // 		title: '投資の先輩コインポリシーについて',
            // 		content: `
            //     <style>
            //     .policy-title1 {
            //       position: relative;
            //       line-height: 150%;
            //       display: inline-block;
            //       max-width: 100%;
            //     }
            //     .amazon {
            //       margin: 0;
            //     }
            //     .policy-body41 {
            //       position: relative;
            //       font-size: 14px;
            //       line-height: 150%;
            //       display: inline-block;
            //       max-width: 100%;
            //     }
            //     .policy-container1 {
            //       position: relative;
            //       background-color: #f7f7f7;
            //       width: 100%;
            //       display: flex;
            //       flex-direction: column;
            //       align-items: flex-start;
            //       justify-content: flex-start;
            //       gap: 12px;
            //       text-align: left;
            //       font-size: 16px;
            //       color: #292a33;
            //       font-family: "Hiragino Kaku Gothic Pro W3";
            //     }
            //     </style>
            //     <div class="policy-container1">
            //   <div class="policy-title1" style="font-weight: 700;">投資の先輩コインポリシーについて</div>
            //   <div class="policy-body41">
            //     <p class="amazon">
            //       本ポリシーは、株式会社富士山マガジンサービス（以下、「当社」）が本サービスにおいて発行するサービス内コイン（以下「コイン」）に関する条件を定めるものです。本ポリシーにおいて別段の定義がある場合を除き、本ポリシーにおいて用いる用語の意味内容は利用規約に従います。
            //     </p>
            //     <p class="amazon">
            //       本ポリシーをよくお読みいただいた上で、コインのご利用をお願いします。コインの受取・利用にあたっては、本ポリシーの内容及び適用に同意したものとみなします。
            //     </p>
            //     <p class="amazon"> </p>
            //     <p class="amazon">第1条（コインの無償付与）</p>
            //     <p class="amazon">
            //       1.当社は、本サービス上に掲載する条件・方法に従い、コインを無償付与することがあります。当社は、無償付与の条件・方法を予告なく変更することができます。
            //     </p>
            //     <p class="amazon"> </p>
            //     <p class="amazon">第2条（コインの利用と管理）</p>
            //     <p class="amazon">
            //       1.お客様は、本サービス上に掲載する条件・方法に従い、コインの利用可能残高の範囲内で、本サービスの利用代金の決済手段としてコインを利用できます。コインを利用した場合、お客様が決済に利用したコインの残高が支払いに充当され、お客様が保有するコインの利用可能残高が減少します。
            //     </p>
            //     <p class="amazon">
            //       2.お客様が保有するコインの利用可能残高、有効期間、利用記録等に関する情報は、本サービス上に表示します。
            //     </p>
            //     <p class="amazon">
            //       3. お客様が、有効期間が異なるコインを保有している場合において、コインを決済手段として利用した場合、有効期間が先に到来するコインが優先的に消費されるものとしお客様はこれに了承します。
            //     </p>
            //     <p class="amazon">
            //       4.お客様は、一度の決済において、コインとコイン以外の決済手段を組み合わせることができないことを了承します。
            //     </p>
            //     <p class="amazon">
            //       5.当社は、コインの利用条件・方法をお客様への予告なく変更することができます。お客様は、これによりお客様に損害が生じた場合でも、当社が一切その責任を負わないことを承認します。
            //     </p>
            //     <p class="amazon"> </p>
            //     <p class="amazon">第3条（コインの払い戻しと換金）</p>
            //     <p class="amazon">
            //       1.
            //       お客様が投稿者に支払うコインについては、当社が代理で受領するものとします。
            //       投稿者が払い戻しを希望する場合は、当月20日までに当社に所定の申請手続きを行うことにより、投稿者は、サービス内で報酬として受け取ったコインをポイントに交換し、そのポイントを投稿者の銀行口座への振込またはAmazonギフト券として出金申請することができます。なお、コインの交換比率は、1コインにつき1ポイントとします。
            //     </p>
            //     <p class="amazon">
            //       2.当該支払金額の出金申請は、月に一度コインに相当する支払金額が1,000円以上となった場合にのみ行うことが出来ます。また、支払金額の受け取りは過去の支払金額全額とし、支払金額の一部の受け取りの申請をすることはできません。なお、Amazonギフト券での払い戻しは、ポイント残高が1,000ポイント未満の場合のみ可能です。
            //     </p>
            //     <p class="amazon">
            //       3.第4条所定のポイントの有効期限が到来した場合、自動的に銀行口座への振込またはAmazonギフト券として出金申請されます。
            //     </p>
            //     <p class="amazon">
            //       4.マイページにおいて、お客様の銀行口座が未登録の場合、Amazon
            //       ギフト券として払い戻しがされるものとします。
            //     </p>
            //     <p class="amazon">
            //       5.当社は、お客様が保有するコインについて、本サービスの利用を終了する場合を含め、いかなる理由においても、払い戻しまたは現金その他の金品（第三者が発行する電子的通貨等を含みます）への換金または交換を行いません。
            //     </p>
            //     <p class="amazon">
            //       6.本サービスが終了した場合、コインは自動的に消滅するものとします。
            //     </p>
            //     <p class="amazon">
            //       7.お客様は、コインの使用権を他のお客様その他第三者に使用させたり、貸与、譲渡、売買、交換、担保供与等をしたりしてはならないものとします。
            //     </p>
            //   </div>
            // </div>
            //     `,
            // 	},
            {
                title: '金融商品取引法に関するポリシー',
                content: `
        <div
      style="
        position: relative;
        background-color: #f7f7f7;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 12px;
        text-align: left;
        font-size: 16px;
        color: #292a33;
        font-family: 'Hiragino Kaku Gothic ProN';
      "
    >
      <div
        style="
          position: relative;
          line-height: 150%;
          display: inline-block;
          font-weight: 700;
          font-family: 'Hiragino Kaku Gothic Pro W6';
        "
      >
        金融商品取引法に関するポリシー
      </div>
      <div
        style="
          position: relative;
          line-height: 150%;
          display: inline-block;
          font-size: 14px;
        "
      >
        <p style="margin: 0; font-size: 15px;font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">投資に関する情報発信について</p>
        <p style="margin: 0">
          お客様が投資顧問契約に基づく助言を行う行為、相場操縦行為、風説の流布にあたるおそれのある行為を行うことは、金融商品取引法に違反し、法令違反行為として禁止されています（利用規約参照）。
        </p>
        <p style="margin: 0">
        本「金融商品取引法に関するポリシー」（以下、「本ポリシー」）は、株式会社富士山マガジンサービス（以下、「当社」）がコミュニティサービス「投資の先輩」（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます。以下、「本サービス」）における投稿者の投稿に関する条件を定めるものです。本ポリシーにおいて別段の定義がある場合を除き、本ポリシーにおいて用いる用語の意味内容は本サービスの利用規約（以下、「本利用規約」）に従います。
        </p>
        <p style="margin: 0">
        本ポリシーをよくお読みいただいた上で、投稿を行って頂くようお願いします。
        </p>
        <p style="margin: 0">&nbsp;</p>
        <p style="margin: 0">
        お客様が投資顧問契約に基づく助言を行う行為、相場操縦行為、風説の流布にあたるおそれのある行為を行うことは、金融商品取引法に違反し、法令違反行為として禁止されています。
        </p>
        <p style="margin: 0">&nbsp;</p>
        <p style="margin: 0">
        当社は、金融庁が示している「金融商品取引業者等向けの総合的な監督指針」（以下、「監督指針」）の記載等を踏まえ、専門家の助言も受けながら本サービスの設計を行うとともに、投稿されている投稿者のコンテンツを確認しています。
        </p>
        <p style="margin: 0">&nbsp;</p>
        <p style="margin: 0">
        以下に当社の金融商品取引法に関するポリシーを記載いたしますので、投稿の際の参考として下さい。
        </p>
        <p style="margin: 0">&nbsp;</p>
        <p style="margin: 0">
          <span
            style="font-size: 15px; font-weight: 700"
            >投資顧問契約に基づく助言を行う行為について</span
          >
        </p>
        <p style="margin: 0">
          <span>
            <span
              >①有価証券の価値、②有価証券関連オプションの対価の額又は有価証券指標の動向、③金融商品の価値の動向の分析に基づく投資判断、④オプションの対価の額又は金融指標の動向に基づく投資判断のコンテンツが含まれる内容については、投資顧問契約に基づく助言（金融商品取引法第2条第8項第11号）にあたります。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>投稿者は、本サービスを利用するにあたり、投資顧問契約に基づく助言に該当し得る投稿とならないよう、注意を払って頂く必要があります。</span>
          </span>
        </p>
        <p style="margin: 0">&nbsp;</p>
        <p style="margin: 0">
          <span>
            <span style="font-weight: 700">「助言」に該当する可能性が高いと考えられるコンテンツ</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >どのような場合に「助言」を行ったものと評価されるかは必ずしも明確でないものの、例えば、以下に関するコンテンツの作成・配信を行うことは、「助言」に該当する可能性が高いと考えられます。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span>1）有価証券の価値に関する判断についてのコンテンツ </span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >2）有価証券以外のデリバティブ取引（CFDやFXを含む）の内容や時期に関する判断ついてのコンテンツ </span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >3）自身の保有銘柄の行動・助言について配信するコンテンツ </span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span style="font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">「助言」に関し注意するべき点</span>
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >配信コンテンツだけでなく、コメント欄における投稿者のコメントやスタンプを含むリアクションも「助言」に該当し得る点にご留意下さい。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span
              >投資の投稿者上にリンクを貼り、リンク先で投資顧問契約又は投資一任契約を締結することもお控ください。投稿者の投稿内で、推奨銘柄情報や投資に関するノウハウをまとめたパンフレット・冊子等を販売することもお控えください。</span
            >
          </span>
        </p>
        <p style="margin: 0">
          <span>
            <span> </span>
          </span>
        </p>
        <p style="margin: 0; font-size: 15px;font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">相場操縦行為について</p>
        <p style="margin: 0">
        金融商品取引法上、相場操縦行為は禁止されています。投稿者は、本サービスを利用するにあたり、相場操縦行為とならないよう、注意を払って頂く必要があります。
        </p>
        <p style="margin: 0">&nbsp;</p>
        <p style="margin: 0">
          「相場操縦行為」とは、「市場において相場を人為的に変動させるにもかかわらず、その相場があたかも自然の需給によって形成されたものであるかのように他人を誤解させるなどによって自己の利益を図ろうとする行為」をいい、以下の行為を指します。
        </p>
        <p style="margin: 0">①仮装・馴合売買（金融商品取引法第159条第1項）</p>
        <p style="margin: 0">
          同一人が、権利の移転を目的とせず、同一の有価証券について同時期に同価格で売りと買いの注文を発注して売買をすること（仮装売買）、複数の者が、あらかじめ通謀し、同一の有価証券について、ある者の売付け（買付け）と同時期に同価格で他人が買い付ける（売り付ける）こと（馴合売買）
        </p>
        <p style="margin: 0">②変動操作取引（金融商品取引法第159条第2項）</p>
        <p style="margin: 0">
          他人を有価証券の売買に誘引する目的をもって、(i)有価証券の売買が活発に行われていると誤解させ、または取引所金融商品市場における上場金融商品等もしくは店頭売買有価証券市場における店頭売買有価証券の相場を変動させるべき一連の有価証券売買等の現実の取引による相場操縦取引とその申込、委託又は受託をすること、(ii)取引所金融商品市場における上場金融商品等または店頭売買有価証券市場における店頭売買有価証券の相場が自己もしくは他人の市場操作によって変動する旨を流布すること、又は(iii)有価証券売買等を行うにあたって重要な事項につき虚偽もしくは誤解を生じさせる表示を故意に行うこと
        </p>
        <p style="margin: 0">③違法な安定操作取引（金融商品取引法第159条第3項）</p>
        <p style="margin: 0">
          金融商品取引法において、政令に定める、条件、対象者、手続き等に違反して、単独または他人と共同して有価証券等の相場をくぎ付けし、固定し、または安定させる目的をもって、一連の有価証券の売買等またはその委託もしくは受託をすること<br/>
        </p>
        <br/>
        <p style="margin: 0; font-size: 15px;font-weight: 700;font-family: 'Hiragino Kaku Gothic Pro W6';">
          風説の流布にあたるおそれのある書き込みについて
        </p>
        <p style="margin: 0">
        有価証券の募集、売出し、もしくは売買その他の取引もしくはデリバティブ取引等のため、または有価証券・オプションまたはデリバティブ取引等にかかる金融商品・金融指標の相場の変動を図る目的をもって、合理的根拠のない噂を広める行為（風説の流布）や他人を錯誤に陥らせるような手段、誘惑・陰険な手段を用いる詐欺的行為（偽計）、暴行・脅迫というような行為は禁止されています（金融商品取引法158条）
        </p>
        <p style="margin: 0">
        投稿者は、本サービスを利用するにあたり、風説の流布にあたるおそれのある書き込みとならないよう、注意を払って頂く必要があります。
        </p>
        <p style="margin: 0">
        本サービスは、お客様の責任と判断により随時投稿が行われる場を提供するサービスです。当社は、お客様が安心して投稿を行うことを提供する責務を有しており、その努力を続けて参りますが、各お客様の個別投稿について遵法性を事前に確認し保証する立場ではないことをご理解頂けますと幸いです。<br/><br/>
        </p>
        <p style="margin: 0"><br/><br/></p>
        <p style="margin: 0">制定日： 2024年4月15日</p>
      </div>
    </div>
        `,
            },
        ],
    },
    {
        title: '投資の先輩ガイドライン',
        items: [
            {
                title: 'コミュニティガイドライン',
                content: `
        <div
      style="
        position: relative;
        background-color: #f7f7f7;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 12px;
        text-align: left;
        font-size: 16px;
        color: #292a33;
        
      "
    >
      <div
        style="
          position: relative;
          line-height: 150%;
          display: inline-block;
          font-weight: 700;
          font-family: 'Hiragino Kaku Gothic Pro W6';
        "
      >
        コミュニティガイドライン
      </div>
      <div
        style="
          position: relative;
          line-height: 150%;
          display: inline-block;
          font-size: 14px;
        "
      >
        <p style="margin: 0">
        株式会社富士山マガジンサービス（以下、「当社」）の運営する、コミュニティサービス「投資の先輩」（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます。以下、「本サービス」）では、全てのお客様が安心して利用できるソーシャルメディアとして存在するために、本コミュニティガイドライン（以下、「本ガイドライン」）を制定しています。
        </p>
        <p style="margin: 0">
        本サービス上に投稿いただくコンテンツにおける、推奨されることについて明記しています。本ガイドラインにおいて別段の定義がある場合を除き、本ガイドラインにおいて用いる用語の意味内容は本サービスの利用規約に従います。
        </p>
        <p style="margin: 0">&nbsp;</p>
        <p style="margin: 0">
          <span
            style="font-size: 15px; font-weight: 700"
            >本サービスコミュニティの質を上げる</span><br/>
          <span>本サービスは、単なる知識共有にとどまらず、お客様同士の成長と連携を促すコミュニティプラットフォームです。</span
          >
        </p>
        <p style="margin: 0">
          良質なコンテンツは、今や手に入れやすいものとなり、公的なレポートから古典的な名著まで、情報は豊富に存在します。
        </p>
        <p style="margin: 0">
          しかし、その知識を「知る」と「理解する」の間には深い溝が存在します。
        </p>
        <p style="margin: 0">
          例えば、投資初期に最適解のひとつを知ることができても、人間の欲望や影響されやすい性格から、無用なリスクを取りに行く初心者は後を絶ちません。
        </p>
        <p style="margin: 0">
          そこで役立つのが、投資の「人間ドラマ」です。本サービスでは、投稿者が自らの投資遍歴を中心とした人間ドラマを率直に公開しています。
        </p>
        <p style="margin: 0">
        お客様は、共感できる実例を通じて、無用な失敗を避ける知恵や洞察を得られます。
        </p>
        <p style="margin: 0">
          ぜひ利用者全体で良いコミュニティを作っていきましょう。
        </p>
        <p style="margin: 0">&nbsp;</p>
        <p style="margin: 0">
          <span
            style="font-size: 15px; font-weight: 700"
            >投稿者としてコンテンツを投稿する</span
          >
          <span
            ><br/>
            投稿者は、動画や音声、画像、テキストで他のお客様にとっても有益となるコンテンツを作成することが可能です。また、投稿者自身のプロフィール情報を充実させることでも、フォロワー数やアクティビティに良い影響を与えることが可能です。以下で紹介するヒントを参考にして、パフォーマンスが高いコンテンツ、お客様ページを作成しましょう。
            </span
          >
        </p>
        <p style="margin: 0">
          お客様からのインタレスト・エンゲージを高め、フォロワーを増やすためにやると良いことは以下です。
        </p>
        <p style="margin: 0">プロフィールの設定をする</p>
        <p style="margin: 0">
          アイコン画像を設定し、どんな人物で、どんな専門性を持つかを明確にすることでフォローしやすくなります。  
        </p>
        <p style="margin: 0">お客様に関連性の高い情報を共有する</p>
        <p style="margin: 0">
          お客様が実際に興味・関心を持てるように、投稿内容を工夫しましょう。
        </p>
        <p style="margin: 0"> </p>
        <p style="margin: 0">メディア（動画・音声・画像）活用をする</p>
        <p style="margin: 0">
          情報は見栄えも重要となります。視覚的な情報は、画面をスクロールするお客様の注意を引くだけでなく、コンテンツをお客様の記憶により長く留めさせることもできます。
        </p>
        <p style="margin: 0"> </p>
        <p style="margin: 0">定期的に投稿する</p>
        <p style="margin: 0">
          本サービスは最新の質の高い情報を共有するコミュニティです。定期的に投稿することでタイムラインの上位に投稿を表示させましょう。
        </p>
        <p style="margin: 0"> </p>
        <p style="margin: 0">他のお客様と交流する</p>
        <p style="margin: 0">
          他のお客様と交流することで、お客様のニーズやトレンドを把握することができます。引用やコメント欄を活用し、関心のあるお客様を惹きつけることができます。
        </p>
        <p style="margin: 0"> </p>
        <p style="margin: 0">他のチャネルを組み合わせる</p>
        <p style="margin: 0">
          他のSNSを利用している場合、さまざまなチャネルを組み合わせ、宣伝することでフォロワー数を増やすことができます。
        </p>
        <p style="margin: 0">&nbsp;</p>
        <p style="margin: 0; font-size: 15px;font-weight: 700">他のお客様をサポートする</p>
        <p style="margin: 0">
          本サービスには有益な情報を提供する優れたお客様が多数登録しています。自身にとって良いと判断したお客様は積極的にフォローし、彼らが定期的に投稿する情報を素早く受け取って下さい。
        </p>
      </div>
    </div>
        `,
            },
        ],
    },
];
exports.masterFAQ = [
    {
        title: '投資の先輩とはどのようなサービスですか？',
        highlightContent: '',
        lines: [
            '「投資の先輩」は、経験豊富な投資家たちのリアルな事例から学び、不要な失敗を回避するための洞察と知識を提供するコミュニティプラットフォームです。',
            '一般的な投資情報だけでは動き出せなかった方でも、共感や信頼を感じられる「先輩」を見つけることで、安心して投資の世界に足を踏み入れ、持続可能な投資活動を始めることができるようサポートします。',
        ],
    },
    {
        title: 'サービスの利用はどのように始めれば良いですか？',
        highlightContent: ' 以下のステップに従ってください。',
        lines: [
            'ウェブサイトにアクセスし、「ログイン・会員登録」ボタンをタップします。\n',
            '必要情報を入力し、アカウントを作成してください。\n',
            'ログイン後、好みに合わせて「先輩投資家」をフォローし、最新の投資情報や洞察を得ることができます。\n',
        ],
    },
    {
        title: '月額料金はいくらですか？無料で利用できるコンテンツはありますか？',
        highlightContent: '「投資の先輩」では、全ての方が利用できる無料の会員登録をご提供しております。無料会員のままでも、基本的なコンテンツのアクセスやコミュニティ機能をお楽しみいただけます。',
        subContent: '\n ',
        lines: ['さらに、投資経験を充実させたい方のために、プレミアムプランを予定しています。\n'],
    },
    {
        title: '先輩投資家の経験談はどのようにして閲覧できますか？',
        highlightContent: ' 先輩投資家の貴重な経験談は、彼らの投資遍歴を綴った「自分史」と、具体的な投資戦略を詳述した「記事」という二つの形式で提供されています。',
        subContent: '\n\n先輩投資家の貴重な経験談は、彼らの投資遍歴を綴った「自分史」と、具体的な投資戦略を詳述した「記事」という二つの形式で提供されています。',
        // lines: [
        // 	'キーワード検索：気になるキーワードを用いて、関連する先輩の自分史や記事を検索することができます。これにより、特定の投資分野や戦略に関する経験談を簡単に見つけることが可能です。\n',
        // 	'おすすめ機能：あなたの興味や活動に基づいて、システムが自動的にオススメする先輩の自分史や記事を閲覧できます。これにより、新たな視点や戦略を発見するきっかけになるかもしれません。\n',
        // 	'ランキング：他のユーザーから高い評価を受けている人気の自分史や記事をランキング形式で確認できます。これは特に、多くの投資家に影響を与えた経験談を知りたい場合に便利です。\n',
        // 	'これらの方法を駆使して、多様な先輩投資家たちの知見に触れ、あなたの投資スキルをさらに磨き上げましょう。\n',
        // ],
        lines: [],
    },
    // {
    // 	title: '自分に合った先輩を見つけるにはどうしたらいいですか？',
    // 	highlightContent:
    // 		'「投資の先輩」では、あなたと相性の良い先輩投資家を見つけるためのいくつかの方法をご提供しています。',
    // 	lines: [
    // 		'キーワード検索：あなたが興味を持っている特定のキーワードで検索を行い、関連する先輩の自分史や記事を見つけることができます。この方法では、特定のテーマや戦略にフォーカスした経験談を探すことが可能です。\n',
    // 		'おすすめ機能：あなたのプロフィールと活動を基に、システムが自動的に選んだオススメの自分史や記事を提供します。あなたの興味に合わせた先輩を簡単に発見できるように設計されています。\n',
    // 		'ランキング：他のユーザーによる評価が高い、人気のある自分史や記事をランキングから探すことができます。これは、幅広いユーザーから支持を受けている信頼性の高い経験談にアクセスする良い方法です。\n',
    // 		'これらの機能を駆使することで、あなたの投資スタイルや関心に合った先輩投資家を効率良く見つけることができます。\n',
    // 	],
    // },
    {
        title: 'SNS機能はどのように利用するのですか？',
        highlightContent: '「投資の先輩」のSNS機能は、一般的なソーシャルメディアプラットフォームと同様に使いやすくなっています。この機能を使うには:',
        lines: [
            'フォローする：興味深い先輩投資家をフォローして、彼らの活動や投稿をあなたのフィードで直接受け取ることができます。\n',
            '閲覧する：フィードで更新される情報を通じて、フォローしている先輩の最新の洞察や情報を確認することが可能です。\n',
            'これにより、同じ興味を持つユーザーとつながり、彼らから新しいアイデアを得たり、相互に学び合ったりすることができます。\n',
        ],
    },
    {
        title: 'メールアドレスの変更方法は？',
        highlightContent: '',
        lines: [
            '下記URLからメールアドレスを変更できます。\n',
            '※投資の先輩では、株式会社富士山マガジンサービスが提供している Fujisan ID をログインに使用しています。',
        ],
        link: 'https://auth.fujisan.co.jp/faccount/profile',
    },
    {
        title: 'ログインできない問題が発生しました。どうすればいいですか？',
        highlightContent: ' 使用しているブラウザの設定メニューから、キャッシュ、およびCookieの削除をお試しください',
        lines: [
            '以下は一般的な手順です',
            '１，[設定] > [プライバシーとセキュリティ] > [閲覧履歴データの消去] または [履歴の消去] を選択します。\n',
            '２，履歴、キャッシュ、Cookieを削除します。',
        ],
    },
];
